import CampaignPollEditor from "../CampaignModal/CampaignPollEditor";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Field, Form, Formik } from "formik";
import { toast } from "react-toastify";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Typography,
  IconButton,
  InputAdornment,
  Tabs,
  Tab,
  Grid,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Paper,
  FormControlLabel,
  Switch,
  Divider,
  FormHelperText
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteIcon from "@material-ui/icons/Delete";
import TelegramCampaignTopicSelect, { parseTelegramTopics } from "./TelegramCampaignTopicSelect";
import TelegramInlineCampaignButtons, { readTelegramButtons } from "./TelegramInlineCampaignButtons";
import SearchIcon from "@material-ui/icons/Search";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChatIcon from "@material-ui/icons/Chat";
import GroupIcon from "@material-ui/icons/Group";
import TimerIcon from "@material-ui/icons/Timer";
import RepeatIcon from "@material-ui/icons/Repeat";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import api from "../../services/api";
// import MessageVariablesPicker from "../MessageVariablesPicker"; // Ya no se usa
import ConfirmationModal from "../ConfirmationModal";
import AttachmentPreview, { FileListPreview } from "../AttachmentPreview";
// ✅ FASE 2: Componentes compartidos
import RecurrenceTab from "../SharedCampaignComponents/RecurrenceTab";
import IntervalTab from "../SharedCampaignComponents/IntervalTab";
// ✅ FASE 2: Validaciones de fecha
import moment from "moment-timezone";
import { getCampaignTimezoneSync } from "../../helpers/getCampaignTimezone";
import DateTimePickerWithTimezone from "../FormFields/DateTimePickerWithTimezone";
import WhatsAppChatPreview, { firstCampaignMessage } from "../WhatsAppChatPreview";
import CampaignMessageComposer from "../CampaignMessageComposer";
import CampaignWizardLayout, { campaignWizardPaper } from "../CampaignWizardLayout";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const whatsappChoiceFields = (raw) => {
  let value = raw;
  try { if (typeof raw === "string") value = JSON.parse(raw); } catch { value = null; }
  return { waChoicesEnabled: !!value, waChoicesMode: value?.type || "buttons", waChoicesBody: value?.body || "", waChoicesOptions: value?.options?.map(row => row.title) || ["", ""] };
};

const useStyles = makeStyles((theme) => ({
  // ✅ CORREGIDO: Root dinámico según tema
  root: {
    display: "flex",
    flexWrap: "wrap",
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : theme.palette.background.paper,
  },
  tabmsg: {
    backgroundColor: theme.palette.campaigntab,
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  btnWrapper: {
    position: "relative",
  },
  // ✅ CORREGIDO: SelectField dinámico según tema
  selectField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiMenuItem-root": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      },
    },
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  primaryButton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    fontWeight: 700,
    textTransform: "none",
    borderRadius: 999,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  secondaryButton: {
    color: theme.palette.primary.main,
    textTransform: "none",
    fontWeight: 700,
    borderRadius: 999,
    "&:hover": {
      backgroundColor: theme.mode === "dark" ? "rgba(129,140,248,0.12)" : "#eef0ff",
    },
  },
  // ✅ CORREGIDO: GroupsContainer dinámico según tema
  groupsContainer: {
    maxHeight: 150,
    overflow: "auto",
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e1e5e9'}`,
    borderRadius: 4,
    padding: 8,
    marginTop: 8,
    backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  // ✅ CORREGIDO: DialogContent dinámico según tema
  dialogContent: {
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#ffffff',
    padding: 0,
    overflow: "hidden !important",
    flex: 1,
    minHeight: 0,
    display: "flex",
  },
  dialogTitle: {
    padding: theme.spacing(2, 3, 1.5),
    [theme.breakpoints.down("sm")]: { padding: theme.spacing(1.5, 2) },
  },
  dialogTitleMain: {
    fontWeight: 800,
    fontSize: 20,
    [theme.breakpoints.down("sm")]: { fontSize: 17 },
  },
  dialogTitleSub: {
    color: theme.palette.text.secondary,
    fontSize: 13,
    marginTop: 2,
  },
  dialogBody: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  dialogFormCol: {
    flex: 1,
    minWidth: 0,
  },
  dialogActions: {
    backgroundColor: theme.mode === 'dark' ? '#111827' : '#ffffff',
    borderTop: `1px solid ${theme.mode === 'dark' ? '#334155' : '#eef0f5'}`,
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      padding: "8px 16px calc(8px + env(safe-area-inset-bottom, 0px))",
      gap: 8,
      "& > .MuiButton-root": { flex: "1 1 auto", minWidth: 0, minHeight: 44, margin: 0 },
    },
  },
}));

const GroupCampaignModal = ({
  open,
  onClose,
  campaignId,
  initialValues,
  initialAttachment = null,
  onSave,
  campaignType = null, // 'UNICA' o 'RECURRENTE' - viene del botón dropdown
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isMounted = useRef(true);
  const { user } = useContext(AuthContext);
  const { companyId } = user;
  const [whatsapps, setWhatsapps] = useState([]);
  const [loading] = useState(false);
  const [availableGroups, setAvailableGroups] = useState([]);
  const [files, setFiles] = useState([]); // NEW: Lista de archivos disponibles
  const [attachment, setAttachment] = useState(null); // NEW: Archivo adjuntado localmente
  const attachmentFile = useRef(null); // NEW: Referencia al input de archivo
  const attachmentRef = useRef(null);
  const mediaClearedRef = useRef(false);
  const [campaignMedia, setCampaignMedia] = useState(null); // NEW: Archivo de campaña existente
  const campaignMediaRef = useRef(null);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [forumsOnly, setForumsOnly] = useState(false);
  const selectedGroupsRef = useRef([]);
  const [copiedGroupsData, setCopiedGroupsData] = useState([]); // ✅ NEW: Datos de grupos copiados para mostrar
  const [hasInitialized, setHasInitialized] = useState(false); // Control de inicialización
  const [confirmModalOpen, setConfirmModalOpen] = useState(false); // NEW: Modal de confirmación
  const [pendingSubmit, setPendingSubmit] = useState(null); // NEW: Datos pendientes de submit
  // ✅ NUEVO (09/12/2025): Estados para modales de confirmación
  const [confirmChangeScheduledDateModalOpen, setConfirmChangeScheduledDateModalOpen] = useState(false);
  // ✅ NUEVO (10/12/2025): Modal de error cuando falta scheduledDate para agregar horarios
  const [missingScheduledDateModalOpen, setMissingScheduledDateModalOpen] = useState(false);
  const [confirmDeleteAllSchedulesModalOpen, setConfirmDeleteAllSchedulesModalOpen] = useState(false);
  const [confirmDisableHourlyScheduleModalOpen, setConfirmDisableHourlyScheduleModalOpen] = useState(false);
  const [confirmChangeRecurrenceTypeModalOpen, setConfirmChangeRecurrenceTypeModalOpen] = useState(false);
  const [confirmDisableRecurrenceModalOpen, setConfirmDisableRecurrenceModalOpen] = useState(false);
  const [pendingScheduledDateChange, setPendingScheduledDateChange] = useState(null); // Para guardar el cambio pendiente de scheduledDate
  const [pendingSchedulesCount, setPendingSchedulesCount] = useState(0); // Para mostrar cantidad de horarios en el modal
  const [pendingOldHour, setPendingOldHour] = useState(null); // Para mostrar hora antigua en el modal
  const [pendingNewHour, setPendingNewHour] = useState(null); // Para mostrar hora nueva en el modal
  const [pendingRecurrenceTypeChange, setPendingRecurrenceTypeChange] = useState(null); // Para guardar el cambio pendiente de recurrenceType
  const [pendingOldRecurrenceType, setPendingOldRecurrenceType] = useState(null); // Para mostrar tipo anterior
  const [pendingNewRecurrenceType, setPendingNewRecurrenceType] = useState(null); // Para mostrar tipo nuevo
  // ✅ NUEVO (09/12/2025): Ref para acceder a setFieldValue desde fuera del contexto de Formik
  const formikSetFieldValueRef = useRef(null);
  // ✅ CORRECCIÓN: Ref para acceder a resetForm desde fuera del contexto de Formik
  const formikResetFormRef = useRef(null);
  const [searchGroupTerm, setSearchGroupTerm] = useState("");
  const [groupPage, setGroupPage] = useState(1);
  const [messageTab, setMessageTab] = useState(0);
  const [configTab, setConfigTab] = useState(0); // ✅ NUEVO: Pestaña principal (0=MENSAJE, 1=INTERVALO para ÚNICA; 0=MENSAJE, 1=INTERVALO, 2=RECURRENCIA para RECURRENTE)
  const [layoutSection, setLayoutSection] = useState("mensaje");
  const [selectedConnection, setSelectedConnection] = useState("all");
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false); // ✅ NEW: Si campaña ya fue completada
  // ✅ NUEVO (08/12/2025): Estado para modal de horarios
  const [hourlyScheduleModalOpen, setHourlyScheduleModalOpen] = useState(false);
  // ✅ NUEVO: Estado para rastrear si el campo de hora fue modificado por el usuario
  const [hourlyScheduleTimeTouched, setHourlyScheduleTimeTouched] = useState(false);
  // ✅ FASE 2: Estados para modales de validación de fecha
  const [datePastModalOpen, setDatePastModalOpen] = useState(false);
  const [datePastMessage, setDatePastMessage] = useState("");
  const [pendingSetFieldValue, setPendingSetFieldValue] = useState(null);
  const [pendingSaveValues, setPendingSaveValues] = useState(null);
  const saveCampaignRef = useRef(null);
  const [shortTimeModalOpen, setShortTimeModalOpen] = useState(false);
  const [shortTimeMessage, setShortTimeMessage] = useState("");
  const [pendingScheduledAt, setPendingScheduledAt] = useState(null);
  const [formatInvalidModalOpen, setFormatInvalidModalOpen] = useState(false);
  const [formatInvalidMessage] = useState("");
  const [sizeExceededModalOpen, setSizeExceededModalOpen] = useState(false);
  // const [sizeExceededMessage, setSizeExceededMessage] = useState(""); // ✅ TODO: Implementar validación de tamaño de archivo
  const [editingScheduleIndex, setEditingScheduleIndex] = useState(null); // null = nuevo, número = editar
  const [hourlyScheduleMessageTab, setHourlyScheduleMessageTab] = useState(0); // Tab separado para modal de horarios
  const [currentSchedule, setCurrentSchedule] = useState({
    time: "",
    message1: "",
    message2: "",
    message3: "",
    message4: "",
    message5: "",
    mediaPath: null,
    mediaName: null,
    mediaFile: null,
    telegramButtons: null
  });
  // ✅ NUEVO: Referencia al input de archivo para modal de horarios
  const hourlyScheduleFileInput = useRef(null);
  const groupsPerPage = 30;

  // ✅ FASE 2: Determinar tipo de campaña (UNICA o RECURRENTE)
  // Extraer valores de initialValues para evitar expresiones complejas en dependencias
  const initialTipo = initialValues?.tipo;
  const initialIsRecurring = initialValues?.isRecurring;
  const initialRecurrenceType = initialValues?.recurrenceType;
  const initialRecurrenceInterval = initialValues?.recurrenceInterval;
  
  const currentCampaignType = React.useMemo(() => {
    if (campaignId && initialValues) {
      // ✅ CORRECCIÓN CRÍTICA: Usar el campo 'tipo' como fuente de verdad principal
      // Si 'tipo' está establecido y es válido, usarlo directamente
      if (initialTipo === 'GRUPO_UNICA' || initialTipo === 'UNICA') {
        return 'UNICA';
      }
      if (initialTipo === 'GRUPO_RECURRENTE' || initialTipo === 'RECURRENTE') {
        return 'RECURRENTE';
      }
      
      // ✅ Si 'tipo' no está establecido, determinar desde otros campos
      // 1. Si isRecurring es explícitamente false, es UNICA
      if (initialIsRecurring === false || initialIsRecurring === 0 || initialIsRecurring === '0') {
        return 'UNICA';
      }
      // 2. Si isRecurring es explícitamente true, es RECURRENTE
      if (initialIsRecurring === true || initialIsRecurring === 1 || initialIsRecurring === '1') {
        return 'RECURRENTE';
      }
      // 3. Si tiene campos de recurrencia configurados, es RECURRENTE
      if (initialRecurrenceType || initialRecurrenceInterval) {
        return 'RECURRENTE';
      }
      // 4. Por defecto, es UNICA
      return 'UNICA';
    }
    // Si no hay campaignId, usar el campaignType del prop
    return campaignType || 'UNICA';
  }, [campaignId, initialValues, initialTipo, initialIsRecurring, initialRecurrenceType, initialRecurrenceInterval, campaignType]);

  useEffect(() => {
    campaignMediaRef.current = campaignMedia;
  }, [campaignMedia]);

  useEffect(() => {
    if (!open || campaignId || !initialAttachment) return undefined;
    setAttachment(initialAttachment);
    attachmentRef.current = initialAttachment;
    return undefined;
  }, [open, campaignId, initialAttachment]);

  // ✅ FASE 2: Inicializar configTab según el tipo de campaña (solo al abrir el modal o cambiar tipo)
  useEffect(() => {
    if (open) {
      // Solo resetear cuando el modal se abre o cambia el tipo de campaña
      // NO resetear cuando configTab cambia (permite navegar entre pestañas)
      if (currentCampaignType === 'RECURRENTE') {
        // Para RECURRENTE: 0=MENSAJE, 1=INTERVALO, 2=RECURRENCIA
        setConfigTab(0); // Empezar en MENSAJE
      } else {
        // Para ÚNICA: 0=MENSAJE, 1=INTERVALO
        setConfigTab(0); // Empezar en MENSAJE
      }
      setMessageTab(0); // Resetear tab de mensajes
      setLayoutSection("mensaje");
    }
  }, [open, currentCampaignType]); // ✅ CORRECCIÓN: Eliminado configTab de dependencias para evitar ciclo infinito

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);


  // Cargar conexiones desde API
  useEffect(() => {
    const loadWhatsapps = async () => {
      if (whatsapps.length > 0) return; // Ya cargadas
      
      try {
        const response = await api.get('/whatsapp/?session=0');
        if (response.data && Array.isArray(response.data)) {
          setWhatsapps(response.data);
          
          // ✅ NUEVO: Si es una copia y aún no se ha establecido el connection, hacerlo aquí
          if (!campaignId && initialValues?.whatsappId && selectedConnection === "all") {
            const whatsappIdValue = initialValues.whatsappId.toString();
            const whatsappExists = whatsapps.some(w => w.id.toString() === whatsappIdValue);
            if (whatsappExists) {
              setSelectedConnection(whatsappIdValue);
            }
          }
        }
      } catch (err) {
        console.error('Error cargando conexiones:', err);
        toastError(err);
        setWhatsapps([]);
      }
    };
    
    if (open) {
      loadWhatsapps();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // Cargar archivos disponibles
  useEffect(() => {
    const loadFiles = async () => {
      if (!open) return;
      
      try {
        const { data } = await api.get("/files/", {
          params: { companyId }
        });
        setFiles(data.files || []);
      } catch (err) {
        console.error('Error cargando archivos:', err);
        toastError(err);
        setFiles([]);
      }
    };
    
    loadFiles();
  }, [open, companyId]);

  const normalizeScheduleTime = (value) => {
    const stringValue = String(value || "").trim();
    const match = stringValue.match(/^(\d{2}:\d{2})/);
    return match ? match[1] : stringValue;
  };

  // ✅ NUEVO: Crear initialState dinámico basado en initialValues
  // ✅ CORRECCIÓN CRÍTICA: Usar useMemo para calcular initialState solo una vez cuando el modal se abre
  // Esto evita que scheduledDate se recalcule en cada render, causando que la hora cambie automáticamente
  const initialState = useMemo(() => {
    const getEditScheduledDate = (campaign) => {
      const masterScheduledDate = campaign.scheduledDate
        ? String(campaign.scheduledDate)
        : "";
      const isRecurringCampaign = Boolean(
        campaign.isRecurring ||
        campaign.tipo === 'GRUPO_RECURRENTE' ||
        campaign.tipo === 'RECURRENTE'
      );
      const hasStarted = Number(campaign.executionCount || 0) > 0;

      if (!isRecurringCampaign || !hasStarted || !campaign.nextScheduledAt) {
        return masterScheduledDate || String(campaign.nextScheduledAt || "");
      }

      // Edit on the next execution date, but keep the master time. nextScheduledAt
      // may point at an hourly secondary execution rather than the daily master.
      const timezone = getCampaignTimezoneSync();
      const masterMoment = moment.tz(masterScheduledDate, 'YYYY-MM-DD HH:mm:ss', timezone);
      const nextExecutionMoment = moment.tz(
        String(campaign.nextScheduledAt),
        'YYYY-MM-DD HH:mm:ss',
        timezone
      );

      if (!masterMoment.isValid() || !nextExecutionMoment.isValid()) {
        return masterScheduledDate || String(campaign.nextScheduledAt);
      }

      return nextExecutionMoment
        .clone()
        .hour(masterMoment.hour())
        .minute(masterMoment.minute())
        .second(masterMoment.second())
        .millisecond(0)
        .format('YYYY-MM-DD HH:mm:ss');
    };
    
    // ✅ CORRECCIÓN CRÍTICA: Si hay initialValues con id (edición), procesarlos completamente
    if (initialValues && initialValues.id) {
      // ✅ Edición: Usar todos los datos de initialValues
      // scheduledDate queda en la fecha de la próxima ejecución para editar campañas activas,
      // sin reemplazar la hora maestra por un horario secundario.
      const scheduledDateValue = getEditScheduledDate(initialValues);
      
      // ✅ Procesar recurrenceDaysOfWeek si existe
      let recurrenceDaysOfWeekValue = "";
      if (initialValues.recurrenceDaysOfWeek) {
        if (Array.isArray(initialValues.recurrenceDaysOfWeek)) {
          recurrenceDaysOfWeekValue = JSON.stringify(initialValues.recurrenceDaysOfWeek);
        } else if (typeof initialValues.recurrenceDaysOfWeek === 'string') {
          recurrenceDaysOfWeekValue = initialValues.recurrenceDaysOfWeek;
        }
      }
      
      return {
        name: initialValues.name || "",
        telegramButtons: initialValues.telegramButtons || [],
        ...whatsappChoiceFields(initialValues.whatsappChoices),
        telegramTopics: parseTelegramTopics(initialValues.telegramTopics),
        whatsappId: initialValues.whatsappId || initialValues.whatsapp?.id || "",
        scheduledDate: scheduledDateValue,
        nextScheduledAt: initialValues.nextScheduledAt || "",
        message1: initialValues.message1 || "",
        message2: initialValues.message2 || "",
        message3: initialValues.message3 || "",
        message4: initialValues.message4 || "",
        message5: initialValues.message5 || "",
        messageInterval: initialValues.messageInterval || 45,
        longerIntervalAfter: initialValues.longerIntervalAfter || 20,
        greaterInterval: initialValues.greaterInterval || 60,
        fileListId: initialValues.fileListId || "",
        // ✅ CAMPOS DE RECURRENCIA
        isRecurring: initialValues.isRecurring !== undefined ? initialValues.isRecurring : (initialValues.tipo === 'GRUPO_RECURRENTE' || initialValues.tipo === 'RECURRENTE'),
        recurrenceType: initialValues.recurrenceType || "",
        recurrenceInterval: initialValues.recurrenceInterval || "",
        recurrenceDaysOfWeek: recurrenceDaysOfWeekValue,
        recurrenceDayOfMonth: initialValues.recurrenceDayOfMonth || "",
        recurrenceEndDate: initialValues.recurrenceEndDate || "",
        maxExecutions: initialValues.maxExecutions || "",
        // ✅ CAMPOS DE HORARIOS MÚLTIPLES
        useHourlySchedule: initialValues.useHourlySchedule || false,
        recurrenceHourlySchedules: initialValues.recurrenceHourlySchedules || 
          (initialValues.hourlySchedules && Array.isArray(initialValues.hourlySchedules) 
            ? initialValues.hourlySchedules.map(schedule => ({
                time: normalizeScheduleTime(schedule.time),
                message1: schedule.message1 || "",
                message2: schedule.message2 || "",
                message3: schedule.message3 || "",
                message4: schedule.message4 || "",
                message5: schedule.message5 || "",
                mediaPath: schedule.mediaPath || null,
                mediaName: schedule.mediaName || null,
                telegramButtons: schedule.telegramButtons ?? null
              }))
            : []),
        companyId,
      };
    }
    
    if (initialValues && !initialValues.id) {
      // Si hay initialValues pero NO tiene id, es una copia
      // ✅ CORRECCIÓN: scheduledDate debe ser string "YYYY-MM-DD HH:mm:ss" en zona empresa
      let scheduledDateValue = "";
      if (initialValues.scheduledDate) {
        // Asegurar que sea string en formato correcto
        scheduledDateValue = String(initialValues.scheduledDate);
      }
      
      return {
        name: initialValues.name || "",
        whatsappId: initialValues.whatsappId || "",
        telegramButtons: initialValues.telegramButtons || [],
        ...whatsappChoiceFields(initialValues.whatsappChoices),
        telegramTopics: parseTelegramTopics(initialValues.telegramTopics),
        scheduledDate: scheduledDateValue,
        nextScheduledAt: initialValues.nextScheduledAt || "",
        message1: initialValues.message1 || "",
        message2: initialValues.message2 || "",
        message3: initialValues.message3 || "",
        message4: initialValues.message4 || "",
        message5: initialValues.message5 || "",
        messageInterval: initialValues.messageInterval || 45,
        longerIntervalAfter: initialValues.longerIntervalAfter || 20,
        greaterInterval: initialValues.greaterInterval || 60,
        fileListId: initialValues.fileListId || "", // ✅ Lista de Archivos
        // ✅ CAMPOS DE RECURRENCIA
        // ✅ CORRECCIÓN CRÍTICA: Si campaignType es 'RECURRENTE' y no hay initialValues.isRecurring, establecer como true
        isRecurring: initialValues.isRecurring !== undefined ? initialValues.isRecurring : (campaignType === 'RECURRENTE'),
        recurrenceType: initialValues.recurrenceType || "",
        recurrenceInterval: initialValues.recurrenceInterval || "",
        recurrenceDaysOfWeek: initialValues.recurrenceDaysOfWeek || "",
        recurrenceDayOfMonth: initialValues.recurrenceDayOfMonth || "",
        recurrenceEndDate: initialValues.recurrenceEndDate || "",
        maxExecutions: initialValues.maxExecutions || "",
        // ✅ CAMPOS DE HORARIOS MÚLTIPLES (08/12/2025)
        useHourlySchedule: initialValues.useHourlySchedule || false,
        recurrenceHourlySchedules: initialValues.recurrenceHourlySchedules || [],
        companyId,
      };
    }
    
    // Estado inicial por defecto
    // ✅ Si es nueva campaña (sin campaignId y sin initialValues), calcular fecha inicial
    const calculateInitialScheduledDate = () => {
      if (!campaignId && !initialValues) {
        const timezone = getCampaignTimezoneSync();
        const nowInCompanyTimezone = moment().tz(timezone);
        let newDate = nowInCompanyTimezone.clone().add(30, 'minutes');
        
        // Validar que no sea en el pasado
        if (newDate.isBefore(nowInCompanyTimezone)) {
          newDate = nowInCompanyTimezone.clone().add(30, 'minutes');
        }
        
        // ✅ DateTimePickerWithTimezone espera formato "YYYY-MM-DD HH:mm:ss"
        return newDate.format('YYYY-MM-DD HH:mm:ss');
      }
      return "";
    };
    
    return {
      name: "",
      telegramButtons: [],
      ...whatsappChoiceFields(null),
      telegramTopics: {},
      whatsappId: "",
      scheduledDate: calculateInitialScheduledDate(),
      nextScheduledAt: "",
      message1: "",
      message2: "",
      message3: "",
      message4: "",
      message5: "",
      messageInterval: 45,
      longerIntervalAfter: 20,
      greaterInterval: 60,
      fileListId: "",
      // ✅ CAMPOS DE RECURRENCIA
      // ✅ CORRECCIÓN CRÍTICA: Si campaignType es 'RECURRENTE', establecer isRecurring como true
      isRecurring: campaignType === 'RECURRENTE',
      recurrenceType: "",
      recurrenceInterval: "",
      recurrenceDaysOfWeek: "",
      recurrenceDayOfMonth: "",
      recurrenceEndDate: "",
      maxExecutions: "",
      // ✅ CAMPOS DE HORARIOS MÚLTIPLES (08/12/2025)
      useHourlySchedule: false,
      recurrenceHourlySchedules: [],
      companyId,
    };
  }, [campaignId, initialValues, companyId, campaignType]); // ✅ Solo recalcular cuando estos valores cambien

  const handleClose = () => {
    syncSelectedGroups([]);
    setAvailableGroups([]);
    setSearchGroupTerm("");
    setGroupPage(1);
    setMessageTab(0);
    setConfigTab(0); // ✅ Resetear pestaña principal a MENSAJE
    setLayoutSection("mensaje");
    setSelectedConnection("all");
    setAttachment(null); // Reset archivo adjunto
    attachmentRef.current = null;
    mediaClearedRef.current = false;
    campaignMediaRef.current = null;
    setCampaignMedia(null); // Reset media de campaña
    setHasInitialized(false); // Reset inicialización
    setIsCompleted(false); // ✅ Reset estado de completada
    // ✅ CORRECCIÓN CRÍTICA: Resetear formulario de Formik para limpiar todos los campos
    if (formikResetFormRef.current) {
      formikResetFormRef.current();
    }
    onClose();
  };

  // ✅ AUTO-CARGA: Cargar grupos automáticamente cuando cambia el filtro de conexión
  useEffect(() => {
    const loadGroups = async () => {
      if (!open || !selectedConnection) return;
      
      setLoadingGroups(true);
      // ✅ CORRECCIÓN: No resetear selectedGroups si estamos editando una campaña
      // Solo resetear si no hay campaignId (nueva campaña o copia)
      if (!campaignId) {
        syncSelectedGroups([]); // Reset selecciones al cambiar filtro solo en nueva campaña
      }
      setSearchGroupTerm(""); // Reset búsqueda
      setGroupPage(1); // Reset página
      
      try {
        if (selectedConnection === "all") {
          // Cargar TODOS los grupos de todas las conexiones
          if (whatsapps && Array.isArray(whatsapps) && whatsapps.length > 0) {
            const allGroupsPromises = whatsapps.map(whatsapp => 
              api.get(`/groups/db/${whatsapp.id}`).then(res => res.data?.groups || [])
            );
            const allGroupsArrays = await Promise.all(allGroupsPromises);
            const allGroups = allGroupsArrays.flat();
            setAvailableGroups(allGroups);
          } else {
            setAvailableGroups([]);
          }
        } else {
          // Cargar solo grupos de la conexión seleccionada
          const response = await api.get(`/groups/db/${selectedConnection}`);
          setAvailableGroups(response.data?.groups || []);
        }
      } catch (err) {
        toastError(err);
        setAvailableGroups([]);
      } finally {
        setLoadingGroups(false);
      }
    };
    
    loadGroups();
  }, [open, selectedConnection, whatsapps, campaignId]);

  // ✅ CORRECCIÓN: Establecer selectedConnection cuando whatsapps se carga y hay initialValues
  useEffect(() => {
    if (initialValues && (initialValues.whatsappId || initialValues.whatsapp?.id) && whatsapps && whatsapps.length > 0) {
      const whatsappIdValue = (initialValues.whatsappId || initialValues.whatsapp.id).toString();
      const whatsappExists = whatsapps.some(w => w.id.toString() === whatsappIdValue);
      if (whatsappExists && selectedConnection === "all") {
        setSelectedConnection(whatsappIdValue);
      }
    }
  }, [whatsapps, initialValues, selectedConnection]);

  // ✅ NUEVO: Cargar datos cuando se copia una campaña (initialValues sin campaignId)
  useEffect(() => {
    if (!campaignId && initialValues && open && !hasInitialized) {
      
      // ✅ NOTA: selectedConnection se establece cuando se cargan los whatsapps (ver useEffect de loadWhatsapps)
      // no lo hacemos aquí porque whatsapps aún no está cargado
      
      // ✅ CORRECCIÓN DE BUG: Cargar grupos desde originalGroupIds (fuente de verdad) O shippings (fallback)
      // ✅ CRÍTICO: Para campañas recurrentes, shippings contiene TODOS los registros de todas las ejecuciones
      // Por eso debemos usar originalGroupIds como fuente de verdad, no shippings
      let uniqueGroupIds = [];
      
      if (initialValues.originalGroupIds) {
        try {
          uniqueGroupIds = JSON.parse(initialValues.originalGroupIds);
        } catch (err) {
          console.error("❌ [GroupCampaignModal] Error parseando originalGroupIds:", err);
        }
      } else if (initialValues.shippings && Array.isArray(initialValues.shippings)) {
        uniqueGroupIds = [...new Set(initialValues.shippings.map(s => s.groupId))];
        setCopiedGroupsData(initialValues.shippings);
      }
      
      if (uniqueGroupIds.length > 0) {
        syncSelectedGroups(uniqueGroupIds);
      }
      
      // Si hay archivo en initialValues, cargar información del archivo
      if (initialValues.mediaPath && initialValues.mediaName) {
        setCampaignMedia({ path: initialValues.mediaPath, name: initialValues.mediaName });
      }
      
      // ✅ Si hay fileListId, también registrar
      if (initialValues.fileListId) {
      }
      
      setHasInitialized(true);
    }
  }, [campaignId, initialValues, open, hasInitialized, whatsapps]);


  // Cargar grupos de la campaña al editar (cuando hay campaignId)
  // ✅ CORRECCIÓN CRÍTICA: Solo cargar desde API si initialValues NO tiene todos los datos necesarios
  // Si handleEditCampaign ya cargó los datos completos, usar esos directamente
  useEffect(() => {
    if (campaignId && open && !hasInitialized) {
      // ✅ Verificar si initialValues ya tiene todos los datos necesarios (viene de handleEditCampaign)
      const hasCompleteData = initialValues && 
        initialValues.id && 
        (initialValues.message1 !== undefined || initialValues.message2 !== undefined || initialValues.message3 !== undefined) &&
        initialValues.scheduledDate !== undefined;
      
      if (hasCompleteData) {
        // ✅ initialValues ya tiene todos los datos, procesarlos directamente
        
        // ✅ Cargar whatsappId y establecer selectedConnection (solo si whatsapps ya está cargado)
        if (initialValues.whatsappId || initialValues.whatsapp?.id) {
          const whatsappIdValue = (initialValues.whatsappId || initialValues.whatsapp.id).toString();
          // ✅ CORRECCIÓN: Solo establecer selectedConnection si el whatsapp existe en la lista
          if (whatsapps && whatsapps.length > 0) {
            const whatsappExists = whatsapps.some(w => w.id.toString() === whatsappIdValue);
            if (whatsappExists) {
              setSelectedConnection(whatsappIdValue);
            }
          }
        }
        
        // ✅ CORRECCIÓN DE BUG: Obtener grupos desde originalGroupIds (fuente de verdad) O groupIds O shippings (fallback)
        // ✅ CRÍTICO: Para campañas recurrentes, shippings contiene TODOS los registros de todas las ejecuciones
        // Por eso debemos usar originalGroupIds como fuente de verdad, no shippings ni groupIds si vienen de shippings
        let uniqueGroupIds = [];
        
        // ✅ CORRECCIÓN: Prioridad 1: originalGroupIds (fuente de verdad para grupos únicos)
        if (initialValues.originalGroupIds) {
          try {
            uniqueGroupIds = JSON.parse(initialValues.originalGroupIds);
          } catch (err) {
            console.error("❌ [GroupCampaignModal] Error parseando originalGroupIds:", err);
          }
        }
        // Prioridad 2: groupIds (viene de handleEditCampaign, pero solo si no hay originalGroupIds)
        // ✅ NOTA: handleEditCampaign ahora también usa originalGroupIds primero, pero por seguridad verificamos aquí también
        else if (initialValues.groupIds && Array.isArray(initialValues.groupIds) && initialValues.groupIds.length > 0) {
          // ✅ CORRECCIÓN: Eliminar duplicados por si acaso groupIds viene de shippings
          uniqueGroupIds = [...new Set(initialValues.groupIds)];
        }
        // Prioridad 3: shippings (solo como fallback si no hay originalGroupIds ni groupIds)
        else if (initialValues.shippings && Array.isArray(initialValues.shippings) && initialValues.shippings.length > 0) {
          uniqueGroupIds = [...new Set(initialValues.shippings.map(s => s.groupId || s.groupDetails?.groupId).filter(id => id))];
        }
        
        if (uniqueGroupIds.length > 0) {
          syncSelectedGroups(uniqueGroupIds);
        }
        
        // Cargar información del archivo si existe
        if (initialValues.mediaPath && initialValues.mediaName) {
          setCampaignMedia({ path: initialValues.mediaPath, name: initialValues.mediaName });
        }
        
        // ✅ Verificar si la campaña ya fue completada
        if (initialValues.status === 'completed' || initialValues.status === 'FINALIZADA') {
          setIsCompleted(true);
          console.log("⚠️ [GroupCampaignModal] Campaña ya completada (solo lectura)");
        }
        
        // ✅ Mapear horarios desde hourlySchedules a recurrenceHourlySchedules
        if (initialValues.useHourlySchedule && initialValues.hourlySchedules && Array.isArray(initialValues.hourlySchedules)) {
          const mappedSchedules = initialValues.hourlySchedules.map(schedule => ({
            time: normalizeScheduleTime(schedule.time),
            message1: schedule.message1 || "",
            message2: schedule.message2 || "",
            message3: schedule.message3 || "",
            message4: schedule.message4 || "",
            message5: schedule.message5 || "",
            mediaPath: schedule.mediaPath || null,
            mediaName: schedule.mediaName || null,
            telegramButtons: schedule.telegramButtons ?? null
          }));
          // ✅ CRÍTICO: Actualizar initialValues con los horarios mapeados
          if (initialValues) {
            initialValues.recurrenceHourlySchedules = mappedSchedules;
          }
        }
        
        setHasInitialized(true);
        return; // ✅ No hacer llamada a API, ya tenemos todos los datos
      }
      
      // ✅ Si initialValues NO tiene todos los datos, cargar desde API
      console.log("📋 [GroupCampaignModal] Cargando datos desde API...");
      api.get(`/group-campaigns/${campaignId}`)
        .then(({ data }) => {
          // ✅ CORRECCIÓN: scheduledDate debe ser string "YYYY-MM-DD HH:mm:ss" en zona empresa
          if (data.scheduledDate) {
            data.scheduledDate = String(data.scheduledDate);
          }
          if (data.nextScheduledAt) {
            data.nextScheduledAt = String(data.nextScheduledAt);
          }
          
          // ✅ CORRECCIÓN: Actualizar initialValues con scheduledDate como string
          if (initialValues) {
            initialValues.scheduledDate = data.scheduledDate || "";
            initialValues.nextScheduledAt = data.nextScheduledAt || "";
          }
          
          // ✅ CORRECCIÓN: Cargar whatsappId y establecer selectedConnection (solo si whatsapps ya está cargado)
          if (data.whatsappId) {
            const whatsappIdValue = data.whatsappId.toString();
            // ✅ CORRECCIÓN: Solo establecer selectedConnection si el whatsapp existe en la lista
            if (whatsapps && whatsapps.length > 0) {
              const whatsappExists = whatsapps.some(w => w.id.toString() === whatsappIdValue);
              if (whatsappExists) {
                setSelectedConnection(whatsappIdValue);
              }
            }
          }
          
          // ✅ CORRECCIÓN DE BUG: Obtener grupos desde originalGroupIds (fuente de verdad) O shippings (fallback)
          // ✅ CRÍTICO: Para campañas recurrentes, shippings contiene TODOS los registros de todas las ejecuciones
          // Por eso debemos usar originalGroupIds como fuente de verdad, no shippings
          let uniqueGroupIds = [];
          
          // Prioridad 1: originalGroupIds (fuente de verdad para grupos únicos)
          if (data.originalGroupIds) {
            try {
              uniqueGroupIds = JSON.parse(data.originalGroupIds);
            } catch (err) {
              console.error("❌ [GroupCampaignModal] Error parseando originalGroupIds:", err);
            }
          }
          // Prioridad 2: shippings (solo como fallback si no hay originalGroupIds)
          else if (data.shippings && Array.isArray(data.shippings) && data.shippings.length > 0) {
            uniqueGroupIds = [...new Set(data.shippings.map(s => s.groupId))];
          }
          
          if (uniqueGroupIds.length > 0) {
            syncSelectedGroups(uniqueGroupIds);
          }
          
          // Cargar información del archivo si existe
          if (data.mediaPath && data.mediaName) {
            setCampaignMedia({ path: data.mediaPath, name: data.mediaName });
          }
          
          // ✅ Verificar si la campaña ya fue completada
          if (data.status === 'completed' || data.status === 'FINALIZADA') {
            setIsCompleted(true);
          }
          
          // ✅ NUEVO (08/12/2025): Mapear horarios desde hourlySchedules a recurrenceHourlySchedules
          if (data.useHourlySchedule && data.hourlySchedules && Array.isArray(data.hourlySchedules) && data.hourlySchedules.length > 0) {
            const mappedSchedules = data.hourlySchedules.map(schedule => ({
              time: normalizeScheduleTime(schedule.time),
              message1: schedule.message1 || "",
              message2: schedule.message2 || "",
              message3: schedule.message3 || "",
              message4: schedule.message4 || "",
              message5: schedule.message5 || "",
              mediaPath: schedule.mediaPath || null,
              mediaName: schedule.mediaName || null,
              telegramButtons: schedule.telegramButtons ?? null
            }));
            // ✅ CRÍTICO: Actualizar initialValues con los horarios mapeados
            if (initialValues) {
              initialValues.recurrenceHourlySchedules = mappedSchedules;
              initialValues.useHourlySchedule = true; // Asegurar que esté activado
            }
          }
          
          setHasInitialized(true);
        })
        .catch(err => {
          console.error("Error cargando campaña:", err);
          toastError(err);
        });
    }
  }, [campaignId, initialValues, open, hasInitialized, whatsapps]);
  
  // ✅ NUEVO: Sincronizar selectedGroups cuando availableGroups se carga y estamos editando
  useEffect(() => {
    if (campaignId && hasInitialized && availableGroups.length > 0 && selectedGroups.length === 0) {
      // Si estamos editando y tenemos grupos disponibles pero no hay grupos seleccionados,
      // intentar cargar desde la campaña nuevamente
      api.get(`/group-campaigns/${campaignId}`)
        .then(({ data }) => {
          // ✅ CORRECCIÓN DE BUG: Usar originalGroupIds como fuente de verdad, no shippings
          let uniqueGroupIds = [];
          
          if (data.originalGroupIds) {
            try {
              uniqueGroupIds = JSON.parse(data.originalGroupIds);
            } catch (err) {
              console.error("❌ [GroupCampaignModal] Error parseando originalGroupIds:", err);
            }
          } else if (data.shippings && Array.isArray(data.shippings) && data.shippings.length > 0) {
            uniqueGroupIds = [...new Set(data.shippings.map(s => s.groupId))];
          }
          
          if (uniqueGroupIds.length > 0) {
            syncSelectedGroups(uniqueGroupIds);
          }
        })
        .catch(err => {
          console.error("Error sincronizando grupos:", err);
        });
    }
  }, [campaignId, hasInitialized, availableGroups.length, selectedGroups.length]);

  // ✅ CORRECCIÓN: La lógica de recurrenceInterval se maneja en el render de Formik
  // pero usando el ref para evitar actualizaciones durante el render inicial

  function syncSelectedGroups(groups) {
    const nextGroups = Array.isArray(groups) ? groups : [];
    selectedGroupsRef.current = nextGroups;
    setSelectedGroups(nextGroups);

    if (formikSetFieldValueRef.current) {
      formikSetFieldValueRef.current('selectedGroups', nextGroups, false);
    }
  }

  const toggleGroupSelection = (groupId) => {
    setSelectedGroups((prev) => {
      const nextGroups = prev.includes(groupId)
        ? prev.filter((id) => id !== groupId)
        : [...prev, groupId];

      selectedGroupsRef.current = nextGroups;

      if (formikSetFieldValueRef.current) {
        formikSetFieldValueRef.current('selectedGroups', nextGroups, false);
      }

      return nextGroups;
    });
  };

  // ✅ ELIMINAR DUPLICADOS de availableGroups antes de filtrar
  const uniqueGroups = Array.from(
    new Map(availableGroups.map(group => [group.groupId, group])).values()
  );

  useEffect(() => { setForumsOnly(false); }, [selectedConnection, open]);

  const filteredGroups = uniqueGroups.filter(
    (group) => (!forumsOnly || group.telegramForum) && (
      group.name?.toLowerCase().includes(searchGroupTerm.toLowerCase()) ||
      group.groupId?.includes(searchGroupTerm))
  );

  const totalPages = Math.ceil(filteredGroups.length / groupsPerPage);
  const startIndex = (groupPage - 1) * groupsPerPage;
  const endIndex = startIndex + groupsPerPage;
  const paginatedGroups = filteredGroups.slice(startIndex, endIndex);

  const handlePrevPage = () => {
    if (groupPage > 1) setGroupPage(groupPage - 1);
  };

  const handleNextPage = () => {
    if (groupPage < totalPages) setGroupPage(groupPage + 1);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    event.target.value = "";
    if (file) {
      attachmentRef.current = file;
      mediaClearedRef.current = false;
      setAttachment(file);
      toast.success(`Archivo seleccionado: ${file.name}`);
    }
  };

  // ✅ NUEVO (09/12/2025): Función para formatear tamaño de archivo
  const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  // ✅ Nueva función: Manejar adjuntar o eliminar archivo
  const handleAttachmentClick = () => {
    if (attachmentRef.current || attachment || campaignMedia) {
      // Hay archivo adjuntado → ELIMINAR
      attachmentRef.current = null;
      mediaClearedRef.current = true;
      campaignMediaRef.current = null;
      setAttachment(null);
      setCampaignMedia(null);
      toast.info("Archivo eliminado");
    } else {
      // No hay archivo → ADJUNTAR
      if (attachmentFile.current) {
        attachmentFile.current.click();
      }
    }
  };

  // ✅ NUEVO (09/12/2025): Handler para cambio de Tipo de Recurrencia
  const handleRecurrenceTypeChange = (newValue, currentValue, setFieldValue, values) => {
    // Si cambia de "diaria" a otro tipo y hay horarios configurados
    if (currentValue === "diaria" && 
        newValue !== "diaria" && 
        values.useHourlySchedule && 
        values.recurrenceHourlySchedules && 
        values.recurrenceHourlySchedules.length > 0) {
      // Guardar cambio pendiente y mostrar modal
      setPendingRecurrenceTypeChange(newValue);
      setPendingOldRecurrenceType("diaria");
      setPendingNewRecurrenceType(newValue);
      setPendingSchedulesCount(values.recurrenceHourlySchedules.length);
      setConfirmChangeRecurrenceTypeModalOpen(true);
    } else {
      // Aplicar cambio directamente
      setFieldValue('recurrenceType', newValue);
      // ✅ NUEVO (09/12/2025): Si cambia a "diaria", establecer automáticamente recurrenceInterval = 1
      if (newValue === "diaria") {
        if (!values.recurrenceInterval || values.recurrenceInterval === "" || values.recurrenceInterval < 1) {
          setFieldValue('recurrenceInterval', 1);
        }
      }
      // Si cambia de "diaria" a otro tipo, desactivar useHourlySchedule automáticamente
      if (currentValue === "diaria" && newValue !== "diaria") {
        setFieldValue('useHourlySchedule', false);
        setFieldValue('recurrenceHourlySchedules', []);
      }
    }
  };

  // ✅ ELIMINADO: handleDisableRecurrence - No se usa (el switch "Habilitar Recurrencia" fue eliminado)

  // ✅ NUEVO (09/12/2025): Confirmar cambio de Tipo de Recurrencia
  const handleConfirmChangeRecurrenceType = (setFieldValue) => {
    if (pendingRecurrenceTypeChange !== null) {
      setFieldValue('recurrenceType', pendingRecurrenceTypeChange);
      // Desactivar useHourlySchedule automáticamente
      setFieldValue('useHourlySchedule', false);
      setFieldValue('recurrenceHourlySchedules', []);
      toast.success(`Tipo de recurrencia cambiado a "${pendingRecurrenceTypeChange}". Los horarios subsecuentes han sido eliminados.`);
    }
    setConfirmChangeRecurrenceTypeModalOpen(false);
    setPendingRecurrenceTypeChange(null);
    setPendingOldRecurrenceType(null);
    setPendingNewRecurrenceType(null);
  };

  // ✅ NUEVO (09/12/2025): Confirmar deshabilitar Recurrencia
  const handleConfirmDisableRecurrence = (setFieldValue) => {
    setFieldValue('isRecurring', false);
    // Limpiar todos los campos de recurrencia
    setFieldValue('recurrenceType', '');
    setFieldValue('recurrenceInterval', '');
    setFieldValue('recurrenceDaysOfWeek', '');
    setFieldValue('recurrenceDayOfMonth', '');
    setFieldValue('recurrenceEndDate', '');
    setFieldValue('maxExecutions', '');
    setFieldValue('useHourlySchedule', false);
    setFieldValue('recurrenceHourlySchedules', []);
    toast.success("Recurrencia desactivada. Todos los horarios subsecuentes han sido eliminados.");
    setConfirmDisableRecurrenceModalOpen(false);
  };

  const handleConfirmAndSave = async () => {
    if (!pendingSubmit) return;
    
    setConfirmModalOpen(false);
    
    // Continuar con el proceso de guardado
    const { values, setSubmitting } = pendingSubmit;
    setPendingSubmit(null);
    
    await processSave(values, setSubmitting);
  };

  const formatScheduledDateForCompare = (dateValue) => {
    if (!dateValue) return "";

    const timezone = getCampaignTimezoneSync();
    const stringValue = String(dateValue).trim();
    if (!stringValue) return "";

    const parsed = stringValue.includes('T')
      ? moment.tz(stringValue, timezone)
      : moment.tz(stringValue, 'YYYY-MM-DD HH:mm:ss', timezone);

    if (parsed.isValid()) {
      return parsed.format('YYYY-MM-DD HH:mm:ss');
    }

    const fallback = moment.tz(stringValue, timezone);
    return fallback.isValid() ? fallback.format('YYYY-MM-DD HH:mm:ss') : stringValue;
  };

  const hasScheduledDateChanged = (dateValue) => {
    if (!campaignId) return true;

    const isStartedRecurringCampaign = Boolean(
      campaignId &&
      (
        initialValues?.isRecurring ||
        initialValues?.tipo === 'GRUPO_RECURRENTE' ||
        initialValues?.tipo === 'RECURRENTE'
      ) &&
      Number(initialValues?.executionCount || 0) > 0
    );
    const initialScheduledDateForCompare = isStartedRecurringCampaign
      ? initialState.scheduledDate
      : initialValues?.scheduledDate || "";

    return formatScheduledDateForCompare(dateValue) !==
      formatScheduledDateForCompare(initialScheduledDateForCompare);
  };

  const handleSave = async (values, setSubmitting) => {
    // ✅ Alerta si no hay fecha programada
    if (!values.scheduledDate) {
      setPendingSubmit({ values, setSubmitting });
      setConfirmModalOpen(true);
      return;
    }
    
    await processSave(values, setSubmitting);
  };

  // ✅ Función para validación manual (similar a CampaignModal)
  const validateForm = (values) => {
    const errors = {};
    
    // Validar nombre
    if (!values.name || values.name.trim() === "") {
      errors.name = "El nombre de la campaña es obligatorio";
    } else if (values.name.trim().length < 3) {
      errors.name = "El nombre debe tener al menos 3 caracteres";
    } else if (values.name.trim().length > 255) {
      errors.name = "El nombre no puede exceder 255 caracteres";
    }
    
    // Validar conexión (whatsappId)
    // ✅ Usar selectedConnection del estado si values.whatsappId no está disponible
    const connectionToValidate = values.whatsappId || selectedConnection;
    if (!connectionToValidate || connectionToValidate === "" || connectionToValidate === "all") {
      errors.whatsappId = "La conexión es obligatoria";
    }
    
    // Validar al menos un grupo seleccionado
    // ✅ Usar values.selectedGroups si existe, sino usar el estado selectedGroups
    const groupsToValidate =
      Array.isArray(values.selectedGroups) && values.selectedGroups.length > 0
        ? values.selectedGroups
        : selectedGroupsRef.current || selectedGroups || [];
    if (groupsToValidate.length === 0) {
      errors.selectedGroups = "Debe seleccionar al menos un grupo";
    }
    
    // Validar fecha programada
    if (!values.scheduledDate || values.scheduledDate === "") {
      errors.scheduledDate = "La fecha programada es obligatoria";
    }
    
    // Validar al menos un mensaje, archivo adjunto o lista de archivos
    const hasAttachment = attachment || campaignMedia;
    const hasFileList = values.fileListId && values.fileListId !== "";
    const hasMessages = (values.message1 && values.message1.trim() !== "") || 
                       (values.message2 && values.message2.trim() !== "") || 
                       (values.message3 && values.message3.trim() !== "") || 
                       (values.message4 && values.message4.trim() !== "") || 
                       (values.message5 && values.message5.trim() !== "");
    
    if (!hasAttachment && !hasFileList && !hasMessages) {
      // Mostrar error en el primer campo de mensaje
      errors.message1 = "Debe incluir al menos un mensaje, un archivo adjunto O una lista de archivos";
    }
    
    // Validar intervalos
    if (!values.messageInterval || values.messageInterval < 5) {
      errors.messageInterval = "El intervalo entre mensajes debe ser al menos 5 segundos";
    }
    if (!values.longerIntervalAfter || values.longerIntervalAfter < 1) {
      errors.longerIntervalAfter = "Debe especificar después de cuántos grupos aplicar intervalo mayor";
    }
    if (!values.greaterInterval || values.greaterInterval < 10) {
      errors.greaterInterval = "El intervalo mayor debe ser al menos 10 segundos";
    }
    
    // ✅ VALIDACIONES DE RECURRENCIA - Usar currentCampaignType en lugar de values.isRecurring
    // Nota: currentCampaignType se determina dinámicamente, pero en validateForm no tenemos acceso directo
    // Por lo tanto, verificamos si hay campos de recurrencia configurados
    const isRecurring = currentCampaignType === 'RECURRENTE' || 
                       (values.recurrenceType && values.recurrenceType !== "") ||
                       (values.recurrenceInterval && values.recurrenceInterval !== "");
    
    if (isRecurring || currentCampaignType === 'RECURRENTE') {
      if (!values.recurrenceType || values.recurrenceType === "") {
        errors.recurrenceType = "El tipo de recurrencia es obligatorio";
      }
      
      // Para recurrencia diaria con horarios múltiples, el intervalo se valida diferente
      if (values.recurrenceType === "diaria" && values.useHourlySchedule) {
        // Si usa horarios múltiples, el intervalo debe ser 1 (ya se establece automáticamente)
        if (!values.recurrenceInterval || values.recurrenceInterval < 1) {
          errors.recurrenceInterval = "El intervalo de recurrencia debe ser al menos 1";
        }
      } else if (values.recurrenceType && values.recurrenceType !== "diaria") {
        // Para otros tipos de recurrencia, validar intervalo normalmente
        if (!values.recurrenceInterval || values.recurrenceInterval === "" || values.recurrenceInterval < 1) {
          errors.recurrenceInterval = "El intervalo de recurrencia es obligatorio y debe ser mayor a 0";
        }
      }
      
      if (values.recurrenceType === "semanal") {
        if (!values.recurrenceDaysOfWeek || values.recurrenceDaysOfWeek === "" || JSON.parse(values.recurrenceDaysOfWeek || "[]").length === 0) {
          errors.recurrenceDaysOfWeek = "Debe seleccionar al menos un día de la semana";
        }
      }
      
      if (values.recurrenceType === "mensual") {
        if (!values.recurrenceDayOfMonth || values.recurrenceDayOfMonth < 1 || values.recurrenceDayOfMonth > 31) {
          errors.recurrenceDayOfMonth = "Debe especificar un día del mes válido (1-31)";
        }
      }
      
      // Validaciones específicas para horarios múltiples
      if (values.useHourlySchedule && values.recurrenceType === "diaria") {
        const hasMasterMessages = 
          (values.message1 && values.message1.trim() !== "") ||
          (values.message2 && values.message2.trim() !== "") ||
          (values.message3 && values.message3.trim() !== "") ||
          (values.message4 && values.message4.trim() !== "") ||
          (values.message5 && values.message5.trim() !== "") ||
          (values.fileListId !== null && values.fileListId !== undefined);
        
        if (!hasMasterMessages) {
          errors.message1 = "Los mensajes maestros son obligatorios cuando 'Enviar por horas múltiples' está activado";
        }
        
        if (!values.recurrenceHourlySchedules || values.recurrenceHourlySchedules.length === 0) {
          errors.recurrenceHourlySchedules = "Debe configurar al menos un horario cuando la opción 'Enviar por horas múltiples' está activada";
        }
      }
    }
    
    return errors;
  };

  const processSave = async (values, setSubmitting, shouldSkipDateCheck = false, shouldSkipShortTimeCheck = false, setFieldValue = null) => {
    try {
      const isEditingStartedRecurringCampaign = Boolean(
        campaignId && values.isRecurring && Number(initialValues?.executionCount || 0) > 0
      );
      const scheduledDateChanged = hasScheduledDateChanged(values.scheduledDate);

      // ✅ FASE 2: Validar fecha programada en el pasado o < 10 minutos
      if (scheduledDateChanged && !isEditingStartedRecurringCampaign && !shouldSkipDateCheck && values.scheduledDate && values.scheduledDate !== "" && values.scheduledDate !== null) {
        const timezone = getCampaignTimezoneSync();
        
        // Parsear scheduledDate en zona empresa
        let scheduledMoment;
        if (values.scheduledDate.includes('T')) {
          scheduledMoment = moment.tz(values.scheduledDate, timezone);
        } else {
          scheduledMoment = moment.tz(values.scheduledDate, 'YYYY-MM-DD HH:mm:ss', timezone);
        }
        
        if (scheduledMoment.isValid()) {
          const nowInCompanyTimezone = moment().tz(timezone);
          const diffMinutes = scheduledMoment.diff(nowInCompanyTimezone, 'minutes', true);
          
          if (scheduledMoment.isBefore(nowInCompanyTimezone)) {
            // Fecha pasada
            const pastDiffMinutes = nowInCompanyTimezone.diff(scheduledMoment, 'minutes');
            const formattedDate = scheduledMoment.format('DD/MM/YYYY HH:mm');
            setDatePastMessage(
              `La fecha programada (${formattedDate}) está en el pasado (hace ${Math.ceil(pastDiffMinutes)} minutos).\n\n¿Desea actualizar la fecha a ahora mismo (hora actual + 2 minutos) para enviar la campaña inmediatamente?`
            );
            setPendingSaveValues(values);
            setPendingSetFieldValue(setFieldValue);
            saveCampaignRef.current = (vals, skipDate, skipShort) => processSave(vals, setSubmitting, skipDate, skipShort, setFieldValue);
            setDatePastModalOpen(true);
            setSubmitting(false);
            return;
          } else if (diffMinutes > 0 && diffMinutes < 10 && !shouldSkipShortTimeCheck) {
            // Fecha futura pero < 10 minutos
            const formattedDate = scheduledMoment.format('DD/MM/YYYY HH:mm');
            setShortTimeMessage(
              `La fecha programada (${formattedDate}) está a menos de 10 minutos (${Math.ceil(diffMinutes)} minutos). Si programa con menos de 10 minutos, no tendrá opción a modificar esta campaña ya que los tiempos son muy cortos para su procesamiento. Se sugiere programar envíos mayores a 30 minutos.`
            );
            setPendingSaveValues(values);
            setPendingScheduledAt(values.scheduledDate);
            saveCampaignRef.current = (vals, skipDate, skipShort) => processSave(vals, setSubmitting, skipDate, skipShort, setFieldValue);
            setShortTimeModalOpen(true);
            setSubmitting(false);
            return;
          }
        }
      }

      // ✅ VALIDACIÓN 1: Nombre obligatorio
      if (!values.name || values.name.trim() === "") {
        toast.error("El nombre de la campaña es obligatorio");
        setSubmitting(false);
        return;
      }
      
      // ✅ VALIDACIÓN 2: Mínimo 1 grupo seleccionado
      const groupsToSave =
        Array.isArray(values.selectedGroups) && values.selectedGroups.length > 0
          ? values.selectedGroups
          : selectedGroupsRef.current || selectedGroups || [];

      if (groupsToSave.length === 0) {
        toast.error("Debe seleccionar al menos un grupo");
        setSubmitting(false);
        return;
      }
      
      // ✅ VALIDACIÓN 3: Archivo, Lista de Archivos o mensaje (al menos uno)
      const hasAttachment = attachment || campaignMedia;
      const hasFileList = values.fileListId && values.fileListId !== ""; // ✅ Nueva validación
      const hasMessages = values.message1 || values.message2 || values.message3 || values.message4 || values.message5;
      
      // ✅ Si NINGUNA de las 3 opciones tiene contenido → ERROR
      if (!hasAttachment && !hasFileList && !hasMessages) {
        toast.error("Debe incluir al menos un mensaje, un archivo adjunto O una lista de archivos");
        setSubmitting(false);
        return;
      }
      
      // ✅ VALIDACIÓN 4: Intervalos obligatorios
      if (!values.messageInterval || values.messageInterval < 5) {
        toast.error("El intervalo entre mensajes debe ser al menos 5 segundos");
        setSubmitting(false);
        return;
      }
      if (!values.longerIntervalAfter || values.longerIntervalAfter < 1) {
        toast.error("Debe especificar después de cuántos grupos aplicar intervalo mayor");
        setSubmitting(false);
        return;
      }
      if (!values.greaterInterval || values.greaterInterval < 10) {
        toast.error("El intervalo mayor debe ser al menos 10 segundos");
        setSubmitting(false);
        return;
      }
      
      // ✅ VALIDACIÓN 5: Validaciones de recurrencia
      if (values.isRecurring) {
        if (!values.recurrenceType || values.recurrenceType === "") {
          toast.error("Debe seleccionar un tipo de recurrencia");
          setSubmitting(false);
          return;
        }
        if (!values.recurrenceInterval || values.recurrenceInterval < 1) {
          toast.error("El intervalo de recurrencia debe ser al menos 1");
          setSubmitting(false);
          return;
        }
        if (values.recurrenceType === "semanal") {
          if (!values.recurrenceDaysOfWeek || values.recurrenceDaysOfWeek === "" || JSON.parse(values.recurrenceDaysOfWeek).length === 0) {
            toast.error("Debe seleccionar al menos un día de la semana");
            setSubmitting(false);
            return;
          }
        }
        if (values.recurrenceType === "mensual") {
          if (!values.recurrenceDayOfMonth || values.recurrenceDayOfMonth < 1 || values.recurrenceDayOfMonth > 31) {
            toast.error("Debe especificar un día del mes válido (1-31)");
            setSubmitting(false);
            return;
          }
        }
        // ✅ NUEVO (08/12/2025): Validación para horarios múltiples
        if (values.useHourlySchedule && values.recurrenceType === "diaria") {
          // ✅ NUEVO (09/12/2025): Validar mensajes maestros obligatorios
          const hasMasterMessages = 
            (values.message1 && values.message1.trim() !== "") ||
            (values.message2 && values.message2.trim() !== "") ||
            (values.message3 && values.message3.trim() !== "") ||
            (values.message4 && values.message4.trim() !== "") ||
            (values.message5 && values.message5.trim() !== "") ||
            (values.fileListId !== null && values.fileListId !== undefined);
          
          if (!hasMasterMessages) {
            toast.error(
              "Los mensajes maestros son obligatorios cuando 'Enviar por horas múltiples' está activado. " +
              "Estos mensajes se usan en la primera ejecución del día (hora programada principal). " +
              "Debe configurar al menos un mensaje (MSG 1-5) o una lista de archivos."
            );
            setSubmitting(false);
            return;
          }
          
          if (!values.recurrenceHourlySchedules || values.recurrenceHourlySchedules.length === 0) {
            toast.error("Debe configurar al menos un horario cuando la opción 'Enviar por horas múltiples' está activada");
            setSubmitting(false);
            return;
          }
          // Validar que cada horario tenga al menos message1
          const invalidSchedules = values.recurrenceHourlySchedules.filter(s => !s.time || !s.message1 || s.message1.trim() === "");
          if (invalidSchedules.length > 0) {
            toast.error("Todos los horarios deben tener una hora y al menos el Mensaje 1 configurado");
            setSubmitting(false);
            return;
          }
          // Validar que no haya horarios duplicados
          const times = values.recurrenceHourlySchedules.map(s => s.time);
          const uniqueTimes = [...new Set(times)];
          if (times.length !== uniqueTimes.length) {
            toast.error("No se pueden tener horarios duplicados");
            setSubmitting(false);
            return;
          }
          
          // ✅ NUEVO (09/12/2025): Validar conflictos con scheduledDate
          if (values.scheduledDate) {
            try {
              const scheduledDateObj = new Date(values.scheduledDate);
              const scheduledHour = String(scheduledDateObj.getHours()).padStart(2, '0') + ':' + String(scheduledDateObj.getMinutes()).padStart(2, '0');
              
              // Validar que ningún horario coincida con scheduledDate
              const conflictSchedule = values.recurrenceHourlySchedules.find(s => s.time === scheduledHour);
              if (conflictSchedule) {
                toast.error(
                  `No puede configurar un horario que coincida con la hora programada principal (${scheduledHour}). ` +
                  `La hora principal siempre usa los mensajes maestros. Por favor, cambie el horario configurado.`
                );
                setSubmitting(false);
                return;
              }
              
              // Validar que todos los horarios sean posteriores a scheduledDate
              const invalidSchedulesBefore = values.recurrenceHourlySchedules.filter(s => s.time <= scheduledHour);
              if (invalidSchedulesBefore.length > 0) {
                toast.error(
                  `Los horarios no pueden ser anteriores o iguales a la hora programada principal (${scheduledHour}). ` +
                  `La hora principal siempre se ejecuta primero. Por favor, configure horarios posteriores a ${scheduledHour}.`
                );
                setSubmitting(false);
                return;
              }
            } catch (error) {
              console.warn("Error validando conflictos con scheduledDate:", error);
            }
          }
        }
        // Si es recurrente, scheduledDate es obligatorio
        if (!values.scheduledDate) {
          toast.error("Las campañas recurrentes deben tener una fecha programada");
          setSubmitting(false);
          return;
        }
      }

      console.log("📤 [GroupCampaignModal] Valores del formulario:", values);
      console.log("📤 [GroupCampaignModal] scheduledDate capturado:", values.scheduledDate);
      console.log("📤 [GroupCampaignModal] Archivo adjunto:", attachment);

      // ✅ FASE 2: Validar fecha programada en el pasado o < 10 minutos
      if (scheduledDateChanged && !isEditingStartedRecurringCampaign && !shouldSkipDateCheck && values.scheduledDate && values.scheduledDate !== "" && values.scheduledDate !== null) {
        const timezone = getCampaignTimezoneSync();
        
        // Parsear scheduledDate en zona empresa (viene como string "YYYY-MM-DDTHH:mm" o similar)
        let scheduledMoment;
        if (values.scheduledDate.includes('T')) {
          // Formato ISO (datetime-local)
          scheduledMoment = moment.tz(values.scheduledDate, timezone);
        } else {
          // Formato "YYYY-MM-DD HH:mm:ss"
          scheduledMoment = moment.tz(values.scheduledDate, 'YYYY-MM-DD HH:mm:ss', timezone);
        }
        
        if (scheduledMoment.isValid()) {
          const nowInCompanyTimezone = moment().tz(timezone);
          const diffMinutes = scheduledMoment.diff(nowInCompanyTimezone, 'minutes', true);
          
          if (scheduledMoment.isBefore(nowInCompanyTimezone)) {
            // Fecha pasada
            const pastDiffMinutes = nowInCompanyTimezone.diff(scheduledMoment, 'minutes');
            const formattedDate = scheduledMoment.format('DD/MM/YYYY HH:mm');
            setDatePastMessage(
              `La fecha programada (${formattedDate}) está en el pasado (hace ${Math.ceil(pastDiffMinutes)} minutos).\n\n¿Desea actualizar la fecha a ahora mismo (hora actual + 2 minutos) para enviar la campaña inmediatamente?`
            );
            setPendingSaveValues(values);
            setPendingSetFieldValue(setFieldValue);
            saveCampaignRef.current = (vals, skipDate, skipShort) => processSave(vals, setSubmitting, skipDate, skipShort, setFieldValue);
            setDatePastModalOpen(true);
            setSubmitting(false);
            return;
          } else if (diffMinutes > 0 && diffMinutes < 10 && !shouldSkipShortTimeCheck) {
            // Fecha futura pero < 10 minutos
            const formattedDate = scheduledMoment.format('DD/MM/YYYY HH:mm');
            setShortTimeMessage(
              `La fecha programada (${formattedDate}) está a menos de 10 minutos (${Math.ceil(diffMinutes)} minutos). Si programa con menos de 10 minutos, no tendrá opción a modificar esta campaña ya que los tiempos son muy cortos para su procesamiento. Se sugiere programar envíos mayores a 30 minutos.`
            );
            setPendingSaveValues(values);
            setPendingScheduledAt(values.scheduledDate);
            saveCampaignRef.current = (vals, skipDate, skipShort) => processSave(vals, setSubmitting, skipDate, skipShort, setFieldValue);
            setShortTimeModalOpen(true);
            setSubmitting(false);
            return;
          }
        }
      }

      const scheduledDateForPayload = campaignId && !scheduledDateChanged
        ? undefined
        : values.scheduledDate || null;

      const isTelegramCampaign = String(whatsapps.find(w => String(w.id) === String(values.whatsappId))?.type || "").toLowerCase() === "telegram";
      const campaignData = {
        name: values.name,
        whatsappChoices: values.waChoicesEnabled && String(whatsapps.find(w => String(w.id) === String(values.whatsappId))?.type || "").toLowerCase() !== "telegram" ? { type: values.waChoicesMode, body: values.waChoicesBody, options: values.waChoicesOptions.map(title => ({ title })) } : null,
        telegramButtons: isTelegramCampaign ? values.telegramButtons || [] : [],
        scheduledDate: scheduledDateForPayload,
        allowShortSchedule: Boolean(shouldSkipShortTimeCheck),
        status: campaignId && ["failed", "cancelled"].includes(initialValues?.status) && values.scheduledDate
          ? "scheduled"
          : undefined,
        groupIds: groupsToSave,
        telegramTopics: Object.fromEntries(Object.entries(parseTelegramTopics(values.telegramTopics)).filter(([groupId]) => groupsToSave.includes(groupId))),
        message1: values.message1 || "",
        message2: values.message2 || "",
        message3: values.message3 || "",
        message4: values.message4 || "",
        message5: values.message5 || "",
        messageInterval: values.messageInterval || 20,
        longerIntervalAfter: values.longerIntervalAfter || 20,
        greaterInterval: values.greaterInterval || 60,
        fileListId: values.fileListId || null, // ✅ Lista de Archivos
        ...(mediaClearedRef.current && !attachmentRef.current
          ? { mediaPath: "", mediaName: "" }
          : !attachmentRef.current && campaignMediaRef.current?.path && campaignMediaRef.current?.name
            ? { mediaPath: campaignMediaRef.current.path, mediaName: campaignMediaRef.current.name }
            : {}),
        // ✅ CAMPOS DE RECURRENCIA
        isRecurring: values.isRecurring || false,
        recurrenceType: values.recurrenceType || null,
        recurrenceInterval: values.recurrenceInterval || null,
        recurrenceDaysOfWeek: values.recurrenceDaysOfWeek || null,
        recurrenceDayOfMonth: values.recurrenceDayOfMonth || null,
        recurrenceEndDate: values.recurrenceEndDate || null,
        maxExecutions: values.maxExecutions || null,
        // ✅ CAMPOS DE HORARIOS MÚLTIPLES (08/12/2025)
        useHourlySchedule: values.useHourlySchedule || false,
        recurrenceHourlySchedules: (values.recurrenceHourlySchedules || []).map(s => ({
          ...s,
          telegramButtons: isTelegramCampaign ? s.telegramButtons ?? null : null
        })),
      };

      console.log(`🔍 [GroupCampaignModal] Valores del formulario - isRecurring: ${values.isRecurring} (tipo: ${typeof values.isRecurring})`);
      
      // ✅ NUEVO (10/01/2026): Subir archivos de horarios múltiples antes de guardar la campaña
      if (values.useHourlySchedule && values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length > 0) {
        console.log("📤 [GroupCampaignModal] Subiendo archivos de horarios múltiples...");
        
        for (let i = 0; i < values.recurrenceHourlySchedules.length; i++) {
          const schedule = values.recurrenceHourlySchedules[i];
          
          // Si tiene mediaFile pero no mediaPath, subir el archivo
          if (schedule.mediaFile && !schedule.mediaPath) {
            try {
              console.log(`📤 [GroupCampaignModal] Subiendo archivo para horario ${schedule.time}: ${schedule.mediaName}`);
              
              const formData = new FormData();
              formData.append("file", schedule.mediaFile);
              
              const uploadResponse = await api.post("/files/upload-single", formData);
              
              // Actualizar el horario con el mediaPath devuelto
              schedule.mediaPath = uploadResponse.data.path;
              schedule.mediaName = uploadResponse.data.name;
              
              // Eliminar mediaFile ya que ya se subió
              delete schedule.mediaFile;
              
              console.log(`✅ [GroupCampaignModal] Archivo subido para horario ${schedule.time}: ${uploadResponse.data.path}`);
            } catch (uploadError) {
              console.error(`❌ [GroupCampaignModal] Error subiendo archivo para horario ${schedule.time}:`, uploadError);
              toast.error(`Error subiendo archivo para horario ${schedule.time}. Por favor, intente nuevamente.`);
              setSubmitting(false);
              return;
            }
          }
        }
        
        // Actualizar campaignData con los horarios actualizados (con mediaPath)
        campaignData.recurrenceHourlySchedules = values.recurrenceHourlySchedules.map(s => ({
          time: normalizeScheduleTime(s.time),
          message1: s.message1 || "",
          message2: s.message2 || "",
          message3: s.message3 || "",
          message4: s.message4 || "",
          message5: s.message5 || "",
          mediaPath: s.mediaPath || null,
          mediaName: s.mediaName || null,
          telegramButtons: isTelegramCampaign ? s.telegramButtons ?? null : null
        }));
        
        console.log("✅ [GroupCampaignModal] Todos los archivos de horarios subidos correctamente");
      }
      
      console.log("📤 [GroupCampaignModal] Enviando datos a backend:", campaignData);
      
      let response;
      if (campaignId) {
        console.log("✏️ [GroupCampaignModal] Actualizando campaña ID:", campaignId);
        response = await api.put(`/group-campaigns/${campaignId}`, campaignData);
        
        // Si hay archivo adjunto, enviarlo
        if (attachmentRef.current) {
          const formData = new FormData();
          formData.append("file", attachmentRef.current);
          await api.post(`/group-campaigns/${campaignId}/media-upload`, formData);
          console.log("📎 [GroupCampaignModal] Archivo adjuntado a campaña");
        }
        
        console.log("✅ [GroupCampaignModal] Respuesta actualización:", response.data);
        toast.success("Campaña actualizada exitosamente");
      } else {
        console.log("➕ [GroupCampaignModal] Creando nueva campaña");
        
        // ✅ CAMBIO CRÍTICO: Para envíos inmediatos sin fecha, NO crear la campaña aún
        // En su lugar, crear la campaña con scheduledDate futuro para que el backend no la procese inmediatamente
        // Luego subir el archivo, y FINALMENTE actualizar scheduledDate a null para que se envíe
        
        if (attachmentRef.current && !campaignData.scheduledDate) {
          // Si hay archivo y no hay fecha, agregar 5 segundos para dar tiempo de subir archivo
          const futureDate = new Date(Date.now() + 5000);
          campaignData.scheduledDate = futureDate.toISOString();
        }
        
        response = await api.post("/group-campaigns", campaignData);
        console.log("✅ [GroupCampaignModal] Respuesta creación:", response.data);
        console.log("📊 [GroupCampaignModal] Estado de campaña:", response.data?.status);
        
        // Si hay archivo adjunto, enviarlo DESPUÉS de crear la campaña
        if (attachmentRef.current && response.data?.id) {
          const formData = new FormData();
          formData.append("file", attachmentRef.current);
          await api.post(`/group-campaigns/${response.data.id}/media-upload`, formData);
          console.log("📎 [GroupCampaignModal] Archivo adjuntado a campaña nueva");
          
          // Si era un envío inmediato sin fecha original, actualizar para que se envíe ahora
          if (!values.scheduledDate) {
            // Actualizar la campaña para quitar la fecha programada y que se envíe inmediatamente
            await api.put(`/group-campaigns/${response.data.id}`, {
              scheduledDate: null
            });
            console.log("⏰ [GroupCampaignModal] Campaña actualizada para envío inmediato después de subir archivo");
          }
        }
        
        toast.success("Campaña creada exitosamente");
        // ✅ CORRECCIÓN CRÍTICA: Resetear formulario después de crear campaña exitosamente
        // Esto asegura que el formulario esté limpio para la próxima creación
        if (formikResetFormRef.current) {
          formikResetFormRef.current();
        }
      }

      if (isMounted.current) {
        setSubmitting(false);
        handleClose();
        onSave();
      }
    } catch (err) {
      if (isMounted.current) {
        setSubmitting(false);
      }
      toastError(err);
    }
  };

  // ✅ NUEVO (08/12/2025): Funciones para manejar modal de horarios
  // Nota: Estas funciones deben estar dentro del render de Formik para acceder a values y setFieldValue

  return (
    <div className={classes.root}>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg" fullScreen={isMobile} scroll="paper" PaperProps={{ style: campaignWizardPaper(isMobile) }}>
        <DialogTitle id="form-dialog-title" className={classes.dialogTitle} disableTypography>
          <Typography className={classes.dialogTitleMain}>
            {campaignId 
              ? (currentCampaignType === 'RECURRENTE' ? "Editar campaña recurrente" : "Editar campaña")
              : (currentCampaignType === 'RECURRENTE' ? "Nueva campaña recurrente" : "Nueva campaña")
            }
          </Typography>
          <Typography className={classes.dialogTitleSub}>
            Configura el mensaje, selecciona los grupos e importa el envío.
          </Typography>
        </DialogTitle>
        <Formik
          initialValues={{
            ...initialState,
            // ✅ CORRECCIÓN CRÍTICA: Si campaignType es 'RECURRENTE', forzar isRecurring a true
            // Esto asegura que aunque initialValues tenga isRecurring: false, se use true para RECURRENTE
            isRecurring: campaignType === 'RECURRENTE' ? true : (campaignId && initialValues?.isRecurring !== undefined ? initialValues.isRecurring : initialState.isRecurring),
            // ✅ Sobrescribir solo campos de recurrencia si hay initialValues (edición)
            ...(campaignId && initialValues ? {
              recurrenceType: initialValues.recurrenceType || "",
              recurrenceInterval: initialValues.recurrenceInterval || "",
              recurrenceDaysOfWeek: initialValues.recurrenceDaysOfWeek || "",
              recurrenceDayOfMonth: initialValues.recurrenceDayOfMonth || "",
              recurrenceEndDate: initialValues.recurrenceEndDate || "",
              maxExecutions: initialValues.maxExecutions || "",
              useHourlySchedule: initialValues.useHourlySchedule || false,
              recurrenceHourlySchedules: initialValues.recurrenceHourlySchedules || [],
            } : {}),
          }}
          enableReinitialize={true}
          // Sin `validate`: Formik bloqueaba el submit en silencio (sin toast ni cambio de pestaña)
          // cuando el error estaba en otra pestaña; onSubmit ya valida y avisa.
          onSubmit={async (values, actions) => {
            // ✅ CORRECCIÓN: Marcar todos los campos con errores como "touched" para mostrar errores visualmente
            const validationErrors = validateForm(values);
            if (Object.keys(validationErrors).length > 0) {
              // ✅ CORRECCIÓN: Establecer errores primero
              actions.setErrors(validationErrors);
              
              // ✅ CORRECCIÓN: Crear objeto touchedFields completo
              const touchedFields = {};
              Object.keys(validationErrors).forEach(fieldName => {
                touchedFields[fieldName] = true;
              });
              
              // ✅ CORRECCIÓN: Usar setTouched con el objeto completo - esto actualiza el estado de Formik inmediatamente
              actions.setTouched(touchedFields);
              
              // ✅ CORRECCIÓN: Cambiar a la pestaña que contiene el primer campo con error
              // Orden de pestañas: 0=MENSAJE, 1=INTERVALO, 2=RECURRENCIA (para RECURRENTE)
              if (validationErrors.selectedGroups) {
                setLayoutSection("destinatarios");
              } else if (validationErrors.name || validationErrors.scheduledDate || validationErrors.whatsappId || validationErrors.message1 || validationErrors.message2 || validationErrors.message3 || validationErrors.message4 || validationErrors.message5) {
                setLayoutSection("mensaje");
                setConfigTab(0);
              } else if (validationErrors.messageInterval || validationErrors.longerIntervalAfter || validationErrors.greaterInterval) {
                setLayoutSection("intervalo");
                setConfigTab(1);
              } else if (validationErrors.recurrenceType || validationErrors.recurrenceInterval || validationErrors.recurrenceDaysOfWeek || validationErrors.recurrenceDayOfMonth || validationErrors.recurrenceHourlySchedules) {
                setLayoutSection("recurrencia");
                setConfigTab(2);
              }
              toast.error(Object.values(validationErrors)[0]);
              
              // No continuar con el submit si hay errores
              actions.setSubmitting(false);
              return;
            }
            
            try {
              await handleSave(values, actions.setSubmitting);
            } catch (error) {
              console.error('[GroupCampaignModal] Error en onSubmit:', error);
            } finally {
              actions.setSubmitting(false);
            }
          }}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({ values, errors, touched, isSubmitting, setFieldValue, resetForm }) => {
            // ✅ NUEVO (09/12/2025): Guardar setFieldValue en ref para acceso desde modales
            // ✅ CORRECCIÓN: Actualizar ref directamente - esto NO causa re-renders
            formikSetFieldValueRef.current = setFieldValue;
            // ✅ CORRECCIÓN CRÍTICA: Guardar resetForm en ref para resetear formulario al cerrar
            formikResetFormRef.current = resetForm;
            
            // ✅ CORRECCIÓN: Mover lógica de recurrenceInterval a useEffect para evitar setState durante render
            // Esta lógica se maneja en un useEffect separado (ver más abajo)
            // ✅ NUEVO (09/12/2025): Función para calcular hora por defecto (+5 minutos)
            const calculateDefaultHour = () => {
              if (!values.scheduledDate) return null;
              
              try {
                // Extraer hora de scheduledDate
                const scheduledDateObj = new Date(values.scheduledDate);
                const scheduledHour = scheduledDateObj.getHours();
                const scheduledMinute = scheduledDateObj.getMinutes();
                
                // Obtener último horario configurado (si existe)
                let lastHour = scheduledHour;
                let lastMinute = scheduledMinute;
                
                if (values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length > 0) {
                  // Ordenar horarios y obtener el último
                  const sortedSchedules = [...values.recurrenceHourlySchedules].sort((a, b) => {
                    const [hA, mA] = a.time.split(':').map(Number);
                    const [hB, mB] = b.time.split(':').map(Number);
                    if (hA !== hB) return hA - hB;
                    return mA - mB;
                  });
                  
                  const lastSchedule = sortedSchedules[sortedSchedules.length - 1];
                  if (lastSchedule && lastSchedule.time) {
                    [lastHour, lastMinute] = lastSchedule.time.split(':').map(Number);
                  }
                }
                
                // Comparar y usar el mayor (hora maestra o último horario)
                let baseHour = scheduledHour;
                let baseMinute = scheduledMinute;
                
                if (lastHour > scheduledHour || (lastHour === scheduledHour && lastMinute > scheduledMinute)) {
                  baseHour = lastHour;
                  baseMinute = lastMinute;
                }
                
                // Agregar 5 minutos
                let newMinute = baseMinute + 5;
                let newHour = baseHour;
                
                if (newMinute >= 60) {
                  newMinute = newMinute - 60;
                  newHour = newHour + 1;
                }
                
                if (newHour >= 24) {
                  newHour = 0;
                }
                
                // Formatear a HH:mm
                return `${String(newHour).padStart(2, '0')}:${String(newMinute).padStart(2, '0')}`;
              } catch (error) {
                console.warn("Error calculando hora por defecto:", error);
                return null;
              }
            };
            
            // La hora mínima del editor depende de la hora maestra. El último
            // horario solo se usa para sugerir el siguiente horario al agregar.
            // Si se usa como mínimo al editar, el horario actual queda forzado
            // a moverse hacia adelante aunque ya sea válido.
            const getMinimumAllowedHour = () => {
              if (!values.scheduledDate) return null;
              
              try {
                const scheduledDateObj = new Date(values.scheduledDate);
                const scheduledHour = scheduledDateObj.getHours();
                const scheduledMinute = scheduledDateObj.getMinutes();
                
                // El selector trabaja en pasos de 5 minutos. El guardado sigue
                // validando que no coincida ni sea anterior a la hora maestra.
                let newMinute = scheduledMinute + 5;
                let newHour = scheduledHour;
                
                if (newMinute >= 60) {
                  newMinute = newMinute - 60;
                  newHour = newHour + 1;
                }
                
                if (newHour >= 24) {
                  newHour = 0;
                }
                
                return {
                  hour: `${String(newHour).padStart(2, '0')}:${String(newMinute).padStart(2, '0')}`,
                  context: `hora maestra: ${String(scheduledHour).padStart(2, '0')}:${String(scheduledMinute).padStart(2, '0')} + 5 minutos`
                };
              } catch (error) {
                console.warn("Error obteniendo hora mínima:", error);
                return null;
              }
            };
            
            // ✅ NUEVO (08/12/2025): Funciones para manejar modal de horarios (dentro de Formik render)
            const handleOpenHourlyScheduleModal = (index = null) => {
              // ✅ NUEVA VALIDACIÓN (10/12/2025): Si es nuevo horario, verificar scheduledDate
              if (index === null) {
                // Es un nuevo horario (no edición)
                if (!values.scheduledDate || values.scheduledDate.trim() === "") {
                  // Mostrar modal de error
                  setMissingScheduledDateModalOpen(true);
                  return; // No abrir el modal de horario
                }
              }
              
              if (index !== null) {
                // Editar horario existente
                const schedule = values.recurrenceHourlySchedules[index];
                setCurrentSchedule({
                  time: normalizeScheduleTime(schedule.time),
                  message1: schedule.message1 || "",
                  message2: schedule.message2 || "",
                  message3: schedule.message3 || "",
                  message4: schedule.message4 || "",
                  message5: schedule.message5 || "",
                  mediaPath: schedule.mediaPath || null,
                  mediaName: schedule.mediaName || null,
                  telegramButtons: schedule.telegramButtons ?? null
                });
                setEditingScheduleIndex(index);
              } else {
                // ✅ NUEVO (09/12/2025): Nuevo horario - calcular hora por defecto
                const defaultHour = calculateDefaultHour();
                setCurrentSchedule({
                  time: defaultHour || "",
                  message1: "",
                  message2: "",
                  message3: "",
                  message4: "",
                  message5: "",
                  mediaPath: null,
                  mediaName: null,
                  mediaFile: null,
                  telegramButtons: null
                });
                setEditingScheduleIndex(null);
              }
              setHourlyScheduleTimeTouched(false); // ✅ Resetear estado "touched" al abrir modal
              setHourlyScheduleModalOpen(true);
            };

            const handleCloseHourlyScheduleModal = () => {
              setHourlyScheduleModalOpen(false);
              setEditingScheduleIndex(null);
              setHourlyScheduleMessageTab(0);
              setHourlyScheduleTimeTouched(false); // ✅ Resetear estado "touched" al cerrar
              setCurrentSchedule({
                time: "",
                message1: "",
                message2: "",
                message3: "",
                message4: "",
                message5: "",
                mediaPath: null,
                mediaName: null,
                mediaFile: null,
                telegramButtons: null
              });
            };

            const handleSaveHourlySchedule = () => {
              // Validar horario
              if (!currentSchedule.time || !/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/.test(currentSchedule.time)) {
                toast.error("Debe ingresar una hora válida en formato HH:mm (ej: 09:30)");
                return;
              }
              if (!currentSchedule.message1 || currentSchedule.message1.trim() === "") {
                toast.error("El Mensaje 1 es obligatorio");
                return;
              }

              const schedules = values.recurrenceHourlySchedules || [];
              
              // ✅ NUEVO (09/12/2025): Validar conflicto con scheduledDate
              if (values.scheduledDate) {
                try {
                  const scheduledDateObj = new Date(values.scheduledDate);
                  const scheduledHour = String(scheduledDateObj.getHours()).padStart(2, '0') + ':' + String(scheduledDateObj.getMinutes()).padStart(2, '0');
                  
                  if (currentSchedule.time === scheduledHour) {
                    toast.error(
                      `No puede configurar un horario que coincida con la hora programada principal (${scheduledHour}). ` +
                      `La hora principal siempre usa los mensajes maestros. Por favor, cambie el horario configurado.`
                    );
                    return;
                  }
                  
                  // ✅ NUEVO (09/12/2025): Validar que horario sea posterior a scheduledDate
                  if (currentSchedule.time <= scheduledHour) {
                    toast.error(
                      `El horario (${currentSchedule.time}) no puede ser anterior o igual a la hora programada principal (${scheduledHour}). ` +
                      `La hora principal siempre se ejecuta primero. Por favor, configure horarios posteriores a ${scheduledHour}.`
                    );
                    return;
                  }
                } catch (error) {
                  console.warn("Error validando conflicto con scheduledDate:", error);
                }
              }
              
              // Verificar duplicado (excepto si estamos editando el mismo)
              const duplicateIndex = schedules.findIndex((s, i) => s.time === currentSchedule.time && i !== editingScheduleIndex);
              if (duplicateIndex !== -1) {
                toast.error(`Ya existe un horario configurado para las ${currentSchedule.time}`);
                return;
              }

              // Verificar límite de 24 horarios
              if (editingScheduleIndex === null && schedules.length >= 24) {
                toast.error("No se pueden configurar más de 24 horarios por día");
                return;
              }

              const newSchedule = {
                time: currentSchedule.time,
                message1: currentSchedule.message1.trim(),
                message2: currentSchedule.message2 ? currentSchedule.message2.trim() : "",
                message3: currentSchedule.message3 ? currentSchedule.message3.trim() : "",
                message4: currentSchedule.message4 ? currentSchedule.message4.trim() : "",
                message5: currentSchedule.message5 ? currentSchedule.message5.trim() : "",
                mediaPath: currentSchedule.mediaPath || null,
                mediaName: currentSchedule.mediaName || null,
                telegramButtons: currentSchedule.telegramButtons ?? null,
                // ✅ NUEVO (10/01/2026): Guardar mediaFile para subirlo antes de guardar la campaña
                mediaFile: currentSchedule.mediaFile || null
              };

              if (editingScheduleIndex !== null) {
                // Editar horario existente
                const newSchedules = [...schedules];
                newSchedules[editingScheduleIndex] = newSchedule;
                setFieldValue('recurrenceHourlySchedules', newSchedules);
              } else {
                // Agregar nuevo horario
                setFieldValue('recurrenceHourlySchedules', [...schedules, newSchedule]);
              }

              handleCloseHourlyScheduleModal();
              toast.success(editingScheduleIndex !== null ? "Horario actualizado correctamente" : "Horario agregado correctamente");
            };
            
            return (
              <>
                <Form style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden" }}>
                  <DialogContent dividers className={classes.dialogContent}>
                    <CampaignWizardLayout
                      sections={[
                        { id: "mensaje", label: "Mensaje", icon: <ChatIcon fontSize="small" />, error: Boolean(errors.name || errors.whatsappId || errors.scheduledDate || errors.message1) },
                        { id: "destinatarios", label: "Destinatarios", icon: <GroupIcon fontSize="small" />, error: Boolean(errors.selectedGroups) },
                        { id: "intervalo", label: "Intervalo", icon: <TimerIcon fontSize="small" /> },
                        ...(currentCampaignType === "RECURRENTE"
                          ? [{ id: "recurrencia", label: "Recurrencia", icon: <RepeatIcon fontSize="small" />, error: Boolean(errors.recurrenceType) }]
                          : []),
                      ]}
                      activeSection={layoutSection}
                      onSectionChange={(id) => {
                        setLayoutSection(id);
                        if (id === "mensaje") setConfigTab(0);
                        if (id === "intervalo") setConfigTab(1);
                        if (id === "recurrencia") setConfigTab(2);
                      }}
                      preview={
                        <WhatsAppChatPreview
                          connectionName={whatsapps.find((w) => String(w.id) === String(values.whatsappId || selectedConnection))?.name}
                          channel={String(whatsapps.find((w) => String(w.id) === String(values.whatsappId || selectedConnection))?.type || "").toLowerCase() === "telegram" ? "telegram" : "whatsapp"}
                          buttons={String(whatsapps.find((w) => String(w.id) === String(values.whatsappId || selectedConnection))?.type || "").toLowerCase() === "telegram" ? values.telegramButtons : []}
                          message={firstCampaignMessage(values, messageTab)}
                          attachment={attachment}
                          mediaPath={campaignMedia?.path}
                          mediaName={attachment?.name || campaignMedia?.name}
                          showVariablesHint={false}
                        />
                      }
                    >
                    {/* ✅ Mensaje de alerta si la campaña ya fue completada */}
                    {isCompleted && (
                      <Paper style={{ 
                        padding: 16, 
                        marginBottom: 16, 
                        backgroundColor: '#e3f2fd',
                        borderLeft: '4px solid #2196f3'
                      }}>
                        <Typography variant="body2" style={{ color: '#1976d2', fontWeight: 'bold' }}>
                          <span role="img" aria-label="Advertencia">⚠️</span> Esta campaña ya fue completada y enviada. Los campos están en modo solo lectura.
                        </Typography>
                      </Paper>
                    )}
                    
                    <Grid spacing={2} container>
                  {(layoutSection === "mensaje") && (
                  <>
                  {/* Nombre y Conexión en una fila */}
                  <Grid xs={12} md={6} item>
                    <TextField
                      label={<span><span role="img" aria-label="Nombre">📝</span> Nombre</span>}
                      name="name"
                      value={values.name || ""}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        // ✅ Limitar a 50 caracteres
                        if (newValue.length <= 50) {
                          setFieldValue('name', newValue);
                        }
                      }}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.textField}
                      disabled={isCompleted} // ✅ Deshabilitar si ya fue completada
                      error={Boolean((touched.name && errors.name) || (values.name && values.name.length > 50))}
                      helperText={
                        values.name && values.name.length > 50
                          ? "Solo se permiten 50 caracteres"
                          : (touched.name && errors.name ? errors.name : "")
                      }
                      inputProps={{
                        maxLength: 50,
                        minLength: 3
                      }}
                      style={{
                        borderColor: values.name && values.name.length > 50 ? '#f44336' : undefined
                      }}
                    />
                  </Grid>

                  <Grid xs={12} md={6} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={`${classes.formControl} ${classes.selectField}`}
                      error={Boolean(touched.whatsappId && errors.whatsappId)}
                    >
                      {/* ✅ CORRECCIÓN: Eliminado InputLabel que se superponía con renderValue */}
                      <Select
                        value={whatsapps && whatsapps.length > 0 && whatsapps.some(w => w.id.toString() === String(values.whatsappId || "")) ? (values.whatsappId || "") : ""}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          setFieldValue('whatsappId', selectedValue);
                          // ✅ Actualizar selectedConnection para el filtro de grupos
                          if (selectedValue === "" || selectedValue === "all") {
                            setSelectedConnection("all");
                          } else {
                            setSelectedConnection(selectedValue);
                          }
                          setSearchGroupTerm("");
                          setGroupPage(1);
                        }}
                        disabled={isCompleted} // ✅ Deshabilitar si ya fue completada
                        displayEmpty
                        renderValue={() => {
                          if (!values.whatsappId || values.whatsappId === "") {
                            return (
                              <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                                <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                                <span>Seleccione una conexión *</span>
                              </div>
                            );
                          }
                          const whatsapp = whatsapps.find(w => w.id === values.whatsappId);
                          if (!whatsapp) {
                            return (
                              <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                                <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                                <span>Seleccione una conexión *</span>
                              </div>
                            );
                          }
                          return (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                  {whatsapp.name || `Conexión ${whatsapp.id}`}
                                </span>
                                <span style={{ fontSize: '12px', color: '#666' }}>
                                  {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                                   whatsapp.name ? whatsapp.name : 
                                   `Conexión ${whatsapp.id}`}
                                </span>
                              </div>
                            </div>
                          );
                        }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                      >
                        {whatsapps && Array.isArray(whatsapps) && whatsapps.length > 0 && whatsapps.map((whatsapp) => (
                          <MenuItem dense key={whatsapp.id} value={whatsapp.id}>
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                              <span style={{ marginRight: '8px', fontSize: '16px' }} role="img" aria-label="WhatsApp">📱</span>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {whatsapp.name || `Conexión ${whatsapp.id}`}
                                  </span>
                                  <span 
                                    style={{ 
                                      fontSize: '10px', 
                                      padding: '2px 6px', 
                                      borderRadius: '10px',
                                      backgroundColor: whatsapp.status === 'CONNECTED' ? '#25d366' : '#e1306c',
                                      color: 'white',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    {whatsapp.status}
                                  </span>
                                </div>
                                <span style={{ fontSize: '12px', color: '#666' }}>
                                  {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                                   whatsapp.name ? whatsapp.name : 
                                   `Conexión ${whatsapp.id}`}
                                </span>
                              </div>
                            </div>
                          </MenuItem>
                        ))}
                      </Select>
                      {touched.whatsappId && errors.whatsappId && (
                        <FormHelperText>{errors.whatsappId}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  </>
                  )}

                  {layoutSection === "mensaje" && String(whatsapps.find(w => String(w.id) === String(values.whatsappId))?.type || "").toLowerCase() !== "telegram" && (
                    <Grid item xs={12}>
                      <CampaignPollEditor interactiveOnly disabled={isCompleted || isSubmitting}
                        values={{ pollEnabled: values.waChoicesEnabled, pollMode: values.waChoicesMode, pollQuestion: values.waChoicesBody, pollOptions: values.waChoicesOptions }}
                        setFieldValue={(field, value) => setFieldValue({ pollEnabled: "waChoicesEnabled", pollMode: "waChoicesMode", pollQuestion: "waChoicesBody", pollOptions: "waChoicesOptions" }[field], value)} />
                    </Grid>
                  )}

                  {layoutSection === "mensaje" && String(whatsapps.find(w => String(w.id) === String(values.whatsappId))?.type || "").toLowerCase() === "telegram" && (
                    <Grid item xs={12}>
                      <TelegramInlineCampaignButtons value={values.telegramButtons}
                        onChange={buttons => setFieldValue("telegramButtons", buttons)} disabled={isCompleted || isSubmitting} />
                    </Grid>
                  )}

                  {layoutSection === "destinatarios" && (
                  <>
                  {/* ✅ FASE 2: CAMPOS GLOBALES (fuera de pestañas) - Lista de Grupos WA */}
                  <Grid xs={12} item>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                      <Box display="flex" alignItems="center">
                        <Typography variant="body2" color="textSecondary" gutterBottom={false}>
                          <span role="img" aria-label="Grupos">👥</span> Lista de Grupos WA *
                        </Typography>
                        {loadingGroups && (
                          <CircularProgress size={16} style={{ marginLeft: 8 }} />
                        )}
                      </Box>
                      {/* ✅ NUEVO (09/12/2025): Botones de selección masiva */}
                      {!loadingGroups && availableGroups.length > 0 && (
                        <Box display="flex" gap={1}>
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                              const allGroupIds = filteredGroups.map(g => g.groupId);
                              syncSelectedGroups(allGroupIds);
                              toast.success(`${allGroupIds.length} grupos seleccionados`);
                            }}
                            disabled={isCompleted}
                            style={{ fontSize: '0.75rem', padding: '4px 8px' }}
                          >
                            <span role="img" aria-label="Seleccionar todo">✓</span> Todos
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            color="secondary"
                            onClick={() => {
                              syncSelectedGroups([]);
                              toast.success("Todos los grupos fueron deseleccionados");
                            }}
                            disabled={isCompleted}
                            style={{ fontSize: '0.75rem', padding: '4px 8px' }}
                          >
                            <span role="img" aria-label="Deseleccionar todo">✗</span> Ninguna
                          </Button>
                        </Box>
                      )}
                    </Box>
                    
                    <TextField
                      placeholder="Buscar grupos..."
                      size="small"
                      value={searchGroupTerm}
                      onChange={(e) => {
                        setSearchGroupTerm(e.target.value);
                        setGroupPage(1);
                      }}
                      disabled={loadingGroups || isCompleted}
                      className={classes.textField}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon color="action" />
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                      margin="dense"
                    />
                    
                    {uniqueGroups.some(group => String(group.groupId).startsWith("tg:")) && (
                      <FormControlLabel control={<Switch checked={forumsOnly} onChange={event => { setForumsOnly(event.target.checked); setGroupPage(1); }} color="primary" />} label="Solo grupos con temas" />
                    )}
                    {/* Contador */}
                    <Typography 
                      variant="body2" 
                      gutterBottom 
                      style={{ 
                        fontWeight: 'bold', 
                        marginTop: 8,
                        color: (touched.selectedGroups && errors.selectedGroups) ? '#d32f2f' : 'primary'
                      }}
                    >
                      <span role="img" aria-label="Seleccionados">✅</span> {selectedGroups.length} {selectedGroups.length === 1 ? 'grupo seleccionado' : 'grupos seleccionados'}
                    </Typography>
                    {/* ✅ Mostrar error si no hay grupos seleccionados */}
                    {touched.selectedGroups && errors.selectedGroups && (
                      <Typography variant="caption" color="error" style={{ display: 'block', marginTop: 4, marginLeft: 14 }}>
                        {errors.selectedGroups}
                      </Typography>
                    )}

                    {/* Vista previa de seleccionados (máximo 5) */}
                    {selectedGroups.length > 0 && (
                      <Box mb={2}>
                        <Typography variant="caption" color="textSecondary" gutterBottom>
                          Vista previa ({selectedGroups.length}):
                        </Typography>
                        <Box display="flex" flexWrap="wrap" gap={1}>
                          {[...new Set(selectedGroups)].slice(0, 5).map((groupId, index) => {
                            const group = availableGroups.find(g => g.groupId === groupId) || 
                                         copiedGroupsData.find(c => c.groupId === groupId) ||
                                         copiedGroupsData.find(c => c.groupDetails?.groupId === groupId);
                            
                            const groupName = group?.name || group?.groupDetails?.name || `Grupo ${groupId}`;
                            
                            return (
                              <Chip
                                key={`${groupId}-${index}`}
                                label={groupName}
                                onDelete={() => toggleGroupSelection(groupId)}
                                color="primary"
                                size="small"
                              />
                            );
                          })}
                          {selectedGroups.length > 5 && (
                            <Chip
                              label={`+${selectedGroups.length - 5} más`}
                              color="primary"
                              size="small"
                              variant="outlined"
                            />
                          )}
                        </Box>
                      </Box>
                    )}

                    {/* Lista de grupos con checkboxes */}
                    <Box className={classes.groupsContainer}>
                      {loadingGroups ? (
                        <Box display="flex" justifyContent="center" alignItems="center" style={{ padding: 32 }}>
                          <CircularProgress />
                          <Typography variant="body2" color="textSecondary" style={{ marginLeft: 16 }}>
                            Cargando grupos...
                          </Typography>
                        </Box>
                      ) : paginatedGroups.length > 0 ? (
                        <>
                          <List dense>
                            {paginatedGroups.map((group) => {
                              const isSelected = selectedGroups.includes(group.groupId);
                              return (
                                <React.Fragment key={group.groupId}>
                                <ListItem
                                  button
                                  onClick={() => !isCompleted && toggleGroupSelection(group.groupId)}
                                  selected={isSelected}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      checked={isSelected}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        if (!isCompleted) {
                                          toggleGroupSelection(group.groupId);
                                        }
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                      disabled={isCompleted}
                                    />
                                  </ListItemIcon>
                                  <ListItemText 
                                    primary={group.name} 
                                    secondary={`${group.groupId}${group.telegramForum ? " · Tiene temas" : ""}`}
                                    primaryTypographyProps={{
                                      style: { 
                                        fontWeight: isSelected ? 'bold' : 'normal',
                                        color: isSelected ? '#1976d2' : 'inherit'
                                      }
                                    }}
                                  />
                                </ListItem>
                                {isSelected && group.telegramForum && (
                                  <TelegramCampaignTopicSelect group={group} value={parseTelegramTopics(values.telegramTopics)[group.groupId]}
                                    disabled={isCompleted || isSubmitting}
                                    onChange={topicId => {
                                      const topics = { ...parseTelegramTopics(values.telegramTopics) };
                                      if (topicId == null) delete topics[group.groupId]; else topics[group.groupId] = topicId;
                                      setFieldValue("telegramTopics", topics);
                                    }} />
                                )}
                                </React.Fragment>
                              );
                            })}
                          </List>
                          {totalPages > 1 && (
                            <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                              <IconButton onClick={handlePrevPage} disabled={groupPage === 1 || isCompleted} size="small">
                                <ChevronLeftIcon />
                              </IconButton>
                              <Typography variant="body2">
                                Página {groupPage} de {totalPages}
                              </Typography>
                              <IconButton onClick={handleNextPage} disabled={groupPage === totalPages || isCompleted} size="small">
                                <ChevronRightIcon />
                              </IconButton>
                            </Box>
                          )}
                        </>
                      ) : (
                        <Typography variant="body2" color="textSecondary" align="center" style={{ padding: 16 }}>
                          No se encontraron grupos
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                  </>
                  )}

                  {layoutSection === "mensaje" && (
                  <>
                  {/* ✅ FASE 2: CAMPOS GLOBALES - Programada y Lista de Archivos */}
                  <Grid xs={12} md={6} item>
                    <DateTimePickerWithTimezone
                      label={
                        <span>
                          <span role="img" aria-label="Fecha programada">📅</span> Programada
                        </span>
                      }
                      value={values.scheduledDate || null}
                      onChange={(newValue) => {
                        // ✅ OPCIÓN 1: Actualizar el campo inmediatamente sin validar (evita confusión mientras edita)
                        // La validación se hará en onBlur cuando el usuario termine de editar
                        setFieldValue('scheduledDate', newValue || "");
                      }}
                      onBlur={() => {
                        // ✅ OPCIÓN 1: Validar solo cuando el usuario termina de editar (onBlur)
                        // Esto evita validaciones confusas mientras el usuario está escribiendo
                        const currentValue = values.scheduledDate;
                        if (currentValue && currentValue !== "") {
                          const scheduledDateChanged = hasScheduledDateChanged(currentValue);
                          const isEditingStartedRecurringCampaign = Boolean(
                            campaignId && values.isRecurring && Number(initialValues?.executionCount || 0) > 0
                          );
                          const campaignTimezone = getCampaignTimezoneSync();
                          
                          // Parsear en zona empresa para validaciones
                          const selectedMoment = moment.tz(currentValue, 'YYYY-MM-DD HH:mm:ss', campaignTimezone);
                          const nowInCompanyTimezone = moment().tz(campaignTimezone);
                          const diffMinutes = selectedMoment.diff(nowInCompanyTimezone, 'minutes', true);
                          
                          // ✅ OPCIÓN 3: Mensaje más claro con ambas fechas visibles
                          if (scheduledDateChanged && !isEditingStartedRecurringCampaign && diffMinutes < -1) {
                            // Fecha pasada - mostrar modal con mensaje mejorado
                            const pastDiffMinutes = nowInCompanyTimezone.diff(selectedMoment, 'minutes');
                            const formattedSelected = selectedMoment.format('DD/MM/YYYY HH:mm');
                            const formattedNow = nowInCompanyTimezone.format('DD/MM/YYYY HH:mm');
                            setDatePastMessage(
                              `La fecha seleccionada (${formattedSelected}) es anterior a la hora actual (${formattedNow}).\n\nDiferencia: ${pastDiffMinutes} minutos en el pasado.\n\n¿Desea actualizar la fecha a ahora mismo (hora actual + 2 minutos) para enviar la campaña inmediatamente?`
                            );
                            setPendingSetFieldValue(() => setFieldValue);
                            setDatePastModalOpen(true);
                          } else if (scheduledDateChanged && !isEditingStartedRecurringCampaign && diffMinutes > 0 && diffMinutes < 10) {
                            // ✅ REGLA DE NEGOCIO: Fecha futura pero < 10 minutos - mostrar modal informativo
                            const formattedDate = selectedMoment.format('DD/MM/YYYY HH:mm');
                            setShortTimeMessage(
                              `La fecha programada (${formattedDate}) está a menos de 10 minutos (${Math.ceil(diffMinutes)} minutos). Si programa con menos de 10 minutos, no tendrá opción a modificar esta campaña ya que los tiempos son muy cortos para su procesamiento. Se sugiere programar envíos mayores a 30 minutos.`
                            );
                            setPendingSetFieldValue(() => setFieldValue);
                            setPendingScheduledAt(currentValue);
                            setShortTimeModalOpen(true);
                          }
                          
                          // ✅ Validar cambio de hora maestra cuando hay sub-tiempos (solo si cambió la hora)
                          if (values.scheduledDate && 
                              values.recurrenceHourlySchedules && 
                              values.recurrenceHourlySchedules.length > 0) {
                            const oldDate = new Date(values.scheduledDate);
                            const newDate = new Date(currentValue);
                            const oldHour = `${String(oldDate.getHours()).padStart(2, '0')}:${String(oldDate.getMinutes()).padStart(2, '0')}`;
                            const newHour = `${String(newDate.getHours()).padStart(2, '0')}:${String(newDate.getMinutes()).padStart(2, '0')}`;
                            if (oldHour !== newHour) {
                              setPendingScheduledDateChange(currentValue);
                              setPendingOldHour(oldHour);
                              setPendingNewHour(newHour);
                              setPendingSchedulesCount(values.recurrenceHourlySchedules.length);
                              setConfirmChangeScheduledDateModalOpen(true);
                            }
                          }
                        }
                      }}
                      timezone={getCampaignTimezoneSync()}
                      error={Boolean(touched.scheduledDate && errors.scheduledDate)}
                      helperText={touched.scheduledDate && errors.scheduledDate ? errors.scheduledDate : undefined}
                      disabled={isCompleted}
                      minDate={(() => {
                        if (campaignId && values.isRecurring && Number(initialValues?.executionCount || 0) > 0) {
                          return undefined;
                        }
                        // Calcular fecha mínima en zona empresa
                        const tz = getCampaignTimezoneSync();
                        const nowInCompanyTimezone = moment().tz(tz);
                        // Extraer valores para crear Date "falso"
                        const year = nowInCompanyTimezone.year();
                        const month = nowInCompanyTimezone.month();
                        const day = nowInCompanyTimezone.date();
                        const hour = nowInCompanyTimezone.hour();
                        const minute = nowInCompanyTimezone.minute();
                        return new Date(year, month, day, hour, minute);
                      })()}
                    />
                  </Grid>

                  <Grid xs={12} md={6} item>
                    <FormControl variant="outlined" margin="dense" className={`${classes.formControl} ${classes.selectField}`} fullWidth>
                      <InputLabel id="fileListId-selection-label"><span role="img" aria-label="Archivos">📁</span> Lista de Archivos</InputLabel>
                      <Field 
                        as={Select} 
                        name="fileListId" 
                        id="fileListId" 
                        labelId="fileListId-selection-label" 
                        defaultValue=""
                        value={values.fileListId || ""}
                        disabled={isCompleted || !!(attachment || campaignMedia)}
                      >
                        <MenuItem value=""><span role="img" aria-label="No definido">❌</span> No definido</MenuItem>
                        {files.map(f => (
                          <MenuItem key={f.id} value={f.id}>
                            <span role="img" aria-label="Archivo">📁</span> {f.name}
                          </MenuItem>
                        ))}
                      </Field>
                    </FormControl>
                    {values.fileListId ? <FileListPreview fileListId={values.fileListId} /> : null}
                  </Grid>

                  {/* ✅ Mensajes MSG 1-5 */}
                  <>
                      {/* ✅ Tabs de Mensajes - MSG 1-5 */}
                      <Grid xs={12} item>
                        <Tabs
                          value={messageTab}
                          indicatorColor="primary"
                          textColor="primary"
                          className={classes.tabmsg}
                          onChange={(e, v) => setMessageTab(v)}
                          variant="fullWidth"
                          centered
                        >
                          {[1, 2, 3, 4, 5].map((num) => (
                            <Tab key={num} label={`MSG. ${num}${values.useHourlySchedule && values.recurrenceType === "diaria" ? " (Maestro)" : ""}`} />
                          ))}
                        </Tabs>
                      </Grid>

                      {/* Área de texto del mensaje */}
                      <Grid xs={12} item>
                        <CampaignMessageComposer
                          id={`message${messageTab + 1}`}
                          label={`Mensaje ${messageTab + 1}${values.useHourlySchedule && values.recurrenceType === "diaria" ? " (Mensaje Maestro - Primera ejecución del día)" : ""}`}
                          value={values[`message${messageTab + 1}`] || ""}
                          onChange={(next) => setFieldValue(`message${messageTab + 1}`, next)}
                          disabled={isCompleted}
                          error={Boolean(touched[`message${messageTab + 1}`] && errors[`message${messageTab + 1}`])}
                          helperText={
                            touched[`message${messageTab + 1}`] && errors[`message${messageTab + 1}`]
                              ? errors[`message${messageTab + 1}`]
                              : values.useHourlySchedule && values.recurrenceType === "diaria"
                                ? "Este mensaje se usará en la primera ejecución del día (hora programada principal)"
                                : ""
                          }
                          placeholder="Escribe el mensaje enviado a los grupos..."
                          variablesScope="system"
                          showAttach={!isCompleted}
                          onAttach={handleAttachmentClick}
                          attachDisabled={!!values.fileListId || !!(attachment || campaignMedia)}
                        />
                        <input
                          ref={attachmentFile}
                          type="file"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                          accept="image/*,video/*,.pdf,.doc,.docx"
                          disabled={isCompleted || !!values.fileListId}
                        />
                        {(attachment || campaignMedia) && (
                          <Box mt={1} mb={1}>
                            <AttachmentPreview
                              file={attachment}
                              mediaPath={!attachment ? campaignMedia?.path : ""}
                              mediaName={attachment?.name || campaignMedia?.name}
                              size="default"
                              onDelete={!isCompleted ? handleAttachmentClick : undefined}
                            />
                          </Box>
                        )}
                      </Grid>
                    </>
                  </>
                  )}

                  {/* ✅ INTERVALO */}
                  {layoutSection === "intervalo" && (
                    <IntervalTab
                      type="groups"
                      totalItems={selectedGroups.length}
                      itemListName={null}
                      values={values}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      errors={errors}
                      disabled={isCompleted}
                      classes={classes}
                    />
                  )}

                  {/* ✅ RECURRENCIA (solo para RECURRENTE) */}
                  {currentCampaignType === "RECURRENTE" && layoutSection === "recurrencia" && (
                    <Grid xs={12} item>
                          {/* ✅ Selector de Tipo de Recurrencia - Directo, sin títulos ni switches redundantes */}
                          <Grid spacing={2} container>
                            <Grid xs={12} md={6} item>
                              <FormControl 
                                variant="outlined" 
                                fullWidth 
                                margin="dense"
                                className={`${classes.formControl} ${classes.selectField}`}
                              >
                                <InputLabel id="recurrenceType-selection-label">
                                  Tipo de Recurrencia
                                </InputLabel>
                                <Select
                                  name="recurrenceType"
                                  label="Tipo de Recurrencia"
                                  labelId="recurrenceType-selection-label"
                                  id="recurrenceType"
                                  value={values.recurrenceType || ""}
                                  disabled={isCompleted}
                                  error={Boolean(touched.recurrenceType && errors.recurrenceType)}
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    handleRecurrenceTypeChange(newValue, values.recurrenceType, setFieldValue, values);
                                  }}
                                >
                                  <MenuItem value="">Seleccione el tipo de recurrencia</MenuItem>
                                  <MenuItem value="diaria">Diaria</MenuItem>
                                  <MenuItem value="semanal">Semanal</MenuItem>
                                  <MenuItem value="quincenal">Quincenal</MenuItem>
                                  <MenuItem value="mensual">Mensual</MenuItem>
                                  <MenuItem value="anual">Anual</MenuItem>
                                </Select>
                                {touched.recurrenceType && errors.recurrenceType ? (
                                  <Typography variant="caption" color="error" style={{ marginLeft: '14px', marginTop: '3px' }}>
                                    {errors.recurrenceType}
                                  </Typography>
                                ) : (
                                  <Typography variant="caption" color="textSecondary" style={{ marginLeft: '14px', marginTop: '3px' }}>
                                    Seleccione el tipo de recurrencia
                                  </Typography>
                                )}
                              </FormControl>
                            </Grid>
                          </Grid>

                          {/* ✅ LÓGICA ESPECÍFICA DE GROUP CAMPAIGNS: "Diaria" con horarios múltiples */}
                          {values.recurrenceType === "diaria" && (
                            <Grid spacing={2} container style={{ marginTop: '8px' }}>
                              {/* ✅ Toggle "Enviar por horas múltiples" - Solo para recurrencia diaria */}
                              <Grid xs={12} item>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={values.useHourlySchedule || false}
                                      onChange={(e) => {
                                        const newValue = e.target.checked;
                                        
                                        // ✅ NUEVO (09/12/2025): Si se está DESHABILITANDO y hay horarios configurados
                                        if (!newValue && 
                                            values.recurrenceHourlySchedules && 
                                            values.recurrenceHourlySchedules.length > 0) {
                                          // Mostrar modal de confirmación
                                          setPendingSchedulesCount(values.recurrenceHourlySchedules.length);
                                          setConfirmDisableHourlyScheduleModalOpen(true);
                                        } else {
                                          // Si se está habilitando o no hay horarios, aplicar directamente
                                          setFieldValue('useHourlySchedule', newValue);
                                          // ✅ NUEVO (09/12/2025): Si se activa useHourlySchedule y es "diaria", establecer recurrenceInterval = 1
                                          if (newValue && values.recurrenceType === "diaria") {
                                            if (!values.recurrenceInterval || values.recurrenceInterval === "" || values.recurrenceInterval < 1) {
                                              setFieldValue('recurrenceInterval', 1);
                                            }
                                          }
                                          if (!newValue) {
                                            setFieldValue('recurrenceHourlySchedules', []);
                                          }
                                        }
                                      }}
                                      disabled={isCompleted}
                                      color="primary"
                                    />
                                  }
                                  label={
                                    <Box>
                                      <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                                        <span role="img" aria-label="reloj">🕐</span> Enviar por horas múltiples
                                      </Typography>
                                      <Typography variant="caption" color="textSecondary">
                                        Configure diferentes mensajes para diferentes horarios del día (ejecuciones subsecuentes). 
                                        Los mensajes maestros (MSG 1-5) siempre se usan en la primera ejecución del día.
                                      </Typography>
                                    </Box>
                                  }
                                />
                              </Grid>

                              {/* ✅ NUEVA SECCIÓN: Horarios de Envío (08/12/2025) - Solo si useHourlySchedule = true y recurrenceType = "diaria" */}
                              {values.useHourlySchedule && values.recurrenceType === "diaria" && (
                                <Grid xs={12} item style={{ marginTop: '16px' }}>
                                  <Divider style={{ margin: '20px 0' }} />
                                  <Typography variant="h6" style={{ marginBottom: '16px', color: theme.mode === 'dark' ? theme.palette.text.primary : '#333' }}>
                                    <span role="img" aria-label="reloj">🕐</span> Horarios de Envío
                                  </Typography>
                                  <Typography variant="body2" style={{ marginBottom: '16px', color: theme.mode === 'dark' ? theme.palette.text.secondary : '#666' }}>
                                    Configure diferentes mensajes para diferentes horarios del día (ejecuciones subsecuentes después de la primera). 
                                    Los horarios se ordenarán automáticamente de forma cronológica. 
                                    <strong style={{ color: theme.mode === 'dark' ? '#fbbf24' : '#d97706' }}> Nota:</strong> La primera ejecución del día (hora programada principal) usa los mensajes maestros (MSG 1-5) configurados arriba.
                                  </Typography>
                                  
                                  {/* Lista de horarios configurados */}
                                  <Box style={{ marginBottom: '16px' }}>
                                    {values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length > 0 ? (
                                      <List>
                                        {values.recurrenceHourlySchedules
                                          .sort((a, b) => a.time.localeCompare(b.time))
                                          .map((schedule, index) => (
                                            <ListItem 
                                              key={index} 
                                              style={{ 
                                                border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#ddd'}`, 
                                                borderRadius: '8px', 
                                                marginBottom: '8px', 
                                                backgroundColor: theme.mode === 'dark' ? '#374151' : '#f9f9f9' 
                                              }}
                                            >
                                              <ListItemText
                                                primary={
                                                  <Box display="flex" alignItems="center" justifyContent="space-between">
                                                    <Typography variant="body1" style={{ fontWeight: 'bold', color: theme.mode === 'dark' ? theme.palette.text.primary : '#333' }}>
                                                      <span role="img" aria-label="reloj">🕐</span> {schedule.time}
                                                    </Typography>
                                                    <Box display="flex" gap={1}>
                                                      <Button
                                                        size="small"
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => handleOpenHourlyScheduleModal(index)}
                                                        disabled={isCompleted}
                                                      >
                                                        Editar
                                                      </Button>
                                                      <Button
                                                        size="small"
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={() => {
                                                          const newSchedules = values.recurrenceHourlySchedules.filter((_, i) => i !== index);
                                                          setFieldValue('recurrenceHourlySchedules', newSchedules);
                                                        }}
                                                        disabled={isCompleted}
                                                      >
                                                        Eliminar
                                                      </Button>
                                                    </Box>
                                                  </Box>
                                                }
                                                secondary={
                                                  <Typography variant="body2" style={{ marginTop: '4px', color: theme.mode === 'dark' ? theme.palette.text.secondary : '#666' }}>
                                                    {schedule.message1 ? `Mensaje: ${schedule.message1.substring(0, 50)}${schedule.message1.length > 50 ? '...' : ''}` : 'Sin mensaje'}
                                                    {schedule.mediaName && ` | Archivo: ${schedule.mediaName}`}
                                                  </Typography>
                                                }
                                              />
                                            </ListItem>
                                          ))}
                                      </List>
                                    ) : (
                                      <Typography variant="body2" style={{ textAlign: 'center', padding: '16px', color: theme.mode === 'dark' ? theme.palette.text.secondary : '#666' }}>
                                        No hay horarios configurados. Agregue al menos un horario para continuar.
                                      </Typography>
                                    )}
                                  </Box>
                                  
                                  {/* Botones para agregar/eliminar horarios */}
                                  <Box display="flex" gap={1} style={{ marginTop: '8px' }}>
                                    <Button
                                      variant="outlined"
                                      color="primary"
                                      onClick={() => handleOpenHourlyScheduleModal(null)}
                                      disabled={isCompleted || (values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length >= 24)}
                                    >
                                      <span role="img" aria-label="agregar">➕</span> Agregar Horario
                                    </Button>
                                    {/* ✅ NUEVO (09/12/2025): Botón "Eliminar todos" */}
                                    {values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length > 0 && (
                                      <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => {
                                          setConfirmDeleteAllSchedulesModalOpen(true);
                                        }}
                                        disabled={isCompleted}
                                      >
                                        <span role="img" aria-label="eliminar">🗑️</span> Eliminar Todos
                                      </Button>
                                    )}
                                  </Box>
                                  {values.recurrenceHourlySchedules && values.recurrenceHourlySchedules.length >= 24 && (
                                    <Typography variant="caption" color="error" style={{ display: 'block', marginTop: '4px' }}>
                                      Máximo 24 horarios por día
                                    </Typography>
                                  )}
                                </Grid>
                              )}
                              
                              {/* Intervalo - Ocultar si useHourlySchedule = true */}
                              {values.recurrenceType === "diaria" && !(values.useHourlySchedule && values.recurrenceType === "diaria") && (
                                <Grid spacing={2} container style={{ marginTop: '8px' }}>
                                  <Grid xs={12} md={6} item>
                                    <TextField
                                      label="Intervalo"
                                      name="recurrenceInterval"
                                      type="number"
                                      value={values.recurrenceInterval === undefined || values.recurrenceInterval === null || values.recurrenceInterval === "" ? 1 : values.recurrenceInterval}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        if (val === "" || val === null || val === undefined) {
                                          setFieldValue('recurrenceInterval', "");
                                        } else {
                                          const numVal = parseInt(val, 10);
                                          setFieldValue('recurrenceInterval', isNaN(numVal) ? "" : numVal);
                                        }
                                      }}
                                      disabled={isCompleted}
                                      helperText="Ejemplo: 1 = cada día, 2 = cada 2 días"
                                      inputProps={{ min: 1, step: 1 }}
                                      error={Boolean(touched.recurrenceInterval && errors.recurrenceInterval)}
                                      variant="outlined"
                                      margin="dense"
                                      fullWidth
                                      className={classes.textField}
                                    />
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          )}

                          {/* ✅ USAR RecurrenceTab COMPARTIDO para Semanal/Mensual/Anual/Quincenal */}
                          {values.recurrenceType && values.recurrenceType !== "" && values.recurrenceType !== "diaria" && (
                            <RecurrenceTab
                              values={values}
                              setFieldValue={setFieldValue}
                              touched={touched}
                              errors={errors}
                              disabled={isCompleted}
                              classes={classes}
                            />
                          )}
                    </Grid>
                  )}
                  </Grid>
                </CampaignWizardLayout>
                </DialogContent>

                <DialogActions className={classes.dialogActions}>
                <Button
                  onClick={handleClose}
                  className={classes.secondaryButton}
                  variant="outlined"
                  disabled={loading || isSubmitting}
                >
                  Cerrar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading || isSubmitting || isCompleted} // ✅ Deshabilitar si ya fue completada
                  className={`${classes.primaryButton} ${classes.btnWrapper}`}
                >
                    {campaignId ? "Actualizar" : "ENVIAR CAMPAÑA"}
                    {(loading || isSubmitting) && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                </DialogActions>
              </Form>
              
              {/* ✅ NUEVO (08/12/2025): Modal para agregar/editar horario */}
              <Dialog 
        open={hourlyScheduleModalOpen} 
        onClose={handleCloseHourlyScheduleModal} 
        fullWidth 
        maxWidth="md"
      >
        <DialogTitle>
          {editingScheduleIndex !== null ? "Editar Horario" : "Agregar Horario"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} style={{ marginTop: '8px' }}>
            {/* Hora - Usar input type="time" para mejor UX */}
            <Grid xs={12} md={6} item>
              {(() => {
                // ✅ NUEVO (09/12/2025): Calcular hora mínima permitida y helper text
                const minHourInfo = getMinimumAllowedHour();
                const minHour = minHourInfo ? minHourInfo.hour : null;
                const context = minHourInfo ? minHourInfo.context : null;
                
                // ✅ NUEVO (09/12/2025): Validación en tiempo real - Solo mostrar error si el usuario modificó el campo
                let errorMessage = null;
                // ✅ Solo validar si el campo fue modificado por el usuario
                if (hourlyScheduleTimeTouched && currentSchedule.time && values.scheduledDate) {
                  try {
                    const scheduledDateObj = new Date(values.scheduledDate);
                    const scheduledHour = `${String(scheduledDateObj.getHours()).padStart(2, '0')}:${String(scheduledDateObj.getMinutes()).padStart(2, '0')}`;
                    
                    if (currentSchedule.time === scheduledHour) {
                      errorMessage = `No puede coincidir con la hora programada principal (${scheduledHour})`;
                    } else if (minHour && currentSchedule.time < minHour) {
                      errorMessage = `La hora debe ser posterior a ${minHour}`;
                    }
                  } catch (error) {
                    console.warn("Error validando hora:", error);
                  }
                }
                
                return (
                  <TextField
                    label="Hora (HH:mm)"
                    type="time"
                    value={currentSchedule.time || ""}
                    style={{ minWidth: 200 }}
                    onChange={(e) => {
                      const timeValue = e.target.value;
                      // ✅ Marcar como "touched" cuando el usuario modifica el campo
                      if (!hourlyScheduleTimeTouched) {
                        setHourlyScheduleTimeTouched(true);
                      }
                      // ✅ NUEVO (09/12/2025): Validación en tiempo real
                      if (timeValue && values.scheduledDate) {
                        try {
                          const scheduledDateObj = new Date(values.scheduledDate);
                          const scheduledHour = `${String(scheduledDateObj.getHours()).padStart(2, '0')}:${String(scheduledDateObj.getMinutes()).padStart(2, '0')}`;
                          
                          if (timeValue === scheduledHour) {
                            toast.error(`No puede coincidir con la hora programada principal (${scheduledHour})`);
                            return;
                          }
                          
                          if (minHour && timeValue < minHour) {
                            toast.error(`La hora debe ser posterior a ${minHour}`);
                            return;
                          }
                        } catch (error) {
                          console.warn("Error validando hora:", error);
                        }
                      }
                      
                      // Si el usuario escribe manualmente, formatear a HH:mm
                      if (timeValue) {
                        setCurrentSchedule({ ...currentSchedule, time: timeValue });
                      } else {
                        setCurrentSchedule({ ...currentSchedule, time: "" });
                      }
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    helperText={
                      errorMessage 
                        ? errorMessage 
                        : minHour 
                          ? `Hora mínima permitida: ${minHour} (${context})` 
                          : "Seleccione la hora o escriba en formato HH:mm (ej: 09:30, 14:15)"
                    }
                    error={!!errorMessage}
                    inputProps={{ 
                      step: 300, // Intervalos de 5 minutos
                      min: minHour || undefined // ✅ NUEVO (09/12/2025): Establecer hora mínima si está disponible
                    }}
                  />
                );
              })()}
            </Grid>
            
            {/* Tabs de Mensajes */}
            <Grid xs={12} item>
              <Tabs
                value={hourlyScheduleMessageTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={(e, v) => setHourlyScheduleMessageTab(v)}
                variant="fullWidth"
                centered
              >
                {[1, 2, 3, 4, 5].map((num) => (
                  <Tab key={num} label={`MSG. ${num}`} />
                ))}
              </Tabs>
            </Grid>
            
            {/* Área de texto del mensaje */}
            <Grid xs={12} item>
              <CampaignMessageComposer
                id={`hourly-message${hourlyScheduleMessageTab + 1}`}
                label={`Mensaje ${hourlyScheduleMessageTab + 1}${hourlyScheduleMessageTab === 0 ? ' (Obligatorio)' : ''}`}
                value={currentSchedule[`message${hourlyScheduleMessageTab + 1}`] || ""}
                onChange={(next) => setCurrentSchedule((prev) => ({ ...prev, [`message${hourlyScheduleMessageTab + 1}`]: next }))}
                placeholder="Escribe el mensaje de este horario..."
                variablesScope="system"
                rows={6}
              />
            </Grid>
            
            {/* ✅ Archivo adjunto (opcional) - Replicando lógica de MENSAJE */}
            <Grid xs={12} item>
              {!currentSchedule.mediaName && (
                <Button
                  color="primary"
                  onClick={() => {
                    if (hourlyScheduleFileInput.current) {
                      hourlyScheduleFileInput.current.click();
                    }
                  }}
                  variant="outlined"
                  startIcon={<AttachFileIcon />}
                  size="small"
                >
                  Adjuntar Archivo
                </Button>
              )}
              {currentSchedule.mediaName && (
                <Box mt={0.5}>
                  <AttachmentPreview
                    file={currentSchedule.mediaFile || null}
                    mediaPath={!currentSchedule.mediaFile ? currentSchedule.mediaPath : ""}
                    mediaName={currentSchedule.mediaName}
                    size="default"
                    onDelete={() => {
                      setCurrentSchedule({
                        ...currentSchedule,
                        mediaName: null,
                        mediaPath: null,
                        mediaFile: null
                      });
                      if (hourlyScheduleFileInput.current) {
                        hourlyScheduleFileInput.current.value = '';
                      }
                      toast.info("Archivo eliminado");
                    }}
                  />
                </Box>
              )}
              <input
                ref={hourlyScheduleFileInput}
                type="file"
                style={{ display: 'none' }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setCurrentSchedule({
                      ...currentSchedule,
                      mediaName: file.name,
                      mediaFile: file,
                      mediaPath: null
                    });
                    toast.success(`Archivo seleccionado: ${file.name}`);
                  }
                }}
                accept="image/*,video/*,.pdf,.doc,.docx"
              />
            </Grid>

            {String(whatsapps.find(w => String(w.id) === String(values.whatsappId))?.type || "").toLowerCase() === "telegram" && (
              <Grid xs={12} item>
                <FormControlLabel
                  control={
                    <Switch
                      color="primary"
                      checked={currentSchedule.telegramButtons === null || currentSchedule.telegramButtons === undefined}
                      onChange={(e) => setCurrentSchedule((prev) => ({
                        ...prev,
                        telegramButtons: e.target.checked ? null : readTelegramButtons(values.telegramButtons)
                      }))}
                    />
                  }
                  label="Usar los mismos botones del mensaje maestro"
                />
                {currentSchedule.telegramButtons !== null && currentSchedule.telegramButtons !== undefined && (
                  <TelegramInlineCampaignButtons
                    value={currentSchedule.telegramButtons}
                    onChange={(buttons) => setCurrentSchedule((prev) => ({ ...prev, telegramButtons: buttons }))}
                  />
                )}
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseHourlyScheduleModal} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleSaveHourlySchedule} color="primary" variant="contained">
            {editingScheduleIndex !== null ? "Actualizar" : "Agregar"}
                </Button>
              </DialogActions>
            </Dialog>
              </>
            );
          }}
        </Formik>
      </Dialog>

      <ConfirmationModal
        title="Envío Inmediato"
        open={confirmModalOpen}
        onClose={() => {
          // ✅ Importante: Resetear setSubmitting cuando se cancela
          if (pendingSubmit?.setSubmitting) {
            pendingSubmit.setSubmitting(false);
          }
          setConfirmModalOpen(false);
          setPendingSubmit(null);
        }}
        onConfirm={handleConfirmAndSave}
      >
        <Box>
          No hay fecha programada configurada.
          <br />
          <br />
          La campaña se enviará <strong>INMEDIATAMENTE</strong> a todos los grupos seleccionados.
          <br />
          <br />
          ¿Desea continuar?
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (10/12/2025): Modal de error cuando falta scheduledDate para agregar horarios */}
      <ConfirmationModal
        title="⚠️ Fecha Programada Requerida"
        open={missingScheduledDateModalOpen}
        onClose={() => setMissingScheduledDateModalOpen(false)}
        onConfirm={() => setMissingScheduledDateModalOpen(false)}
        confirmText="Entendido"
        showCancel={false}
      >
        <Box>
          Para agregar horarios de envío, primero debe configurar la <strong>Fecha y Hora Programada</strong> (hora maestra).
          <br />
          <br />
          Los horarios de envío son ejecuciones subsecuentes que ocurren <strong>después</strong> de la primera ejecución del día.
          <br />
          <br />
          Por favor, configure la fecha y hora programada antes de agregar horarios.
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (09/12/2025): Modal de confirmación para cambio de hora maestra */}
      <ConfirmationModal
        title="⚠️ Cambio de Hora Programada Principal"
        open={confirmChangeScheduledDateModalOpen}
        onClose={() => {
          setConfirmChangeScheduledDateModalOpen(false);
          setPendingScheduledDateChange(null);
          setPendingOldHour(null);
          setPendingNewHour(null);
          setPendingSchedulesCount(0);
        }}
        onConfirm={() => {
          if (formikSetFieldValueRef.current && pendingScheduledDateChange) {
            formikSetFieldValueRef.current('scheduledDate', pendingScheduledDateChange);
            formikSetFieldValueRef.current('recurrenceHourlySchedules', []);
            toast.success("Se eliminaron los horarios subsecuentes debido al cambio de hora principal");
            setPendingScheduledDateChange(null);
            setPendingOldHour(null);
            setPendingNewHour(null);
            setPendingSchedulesCount(0);
          }
          setConfirmChangeScheduledDateModalOpen(false);
        }}
        confirmText="Continuar"
        cancelText="Cancelar"
      >
        <Box>
          Ya hay {pendingSchedulesCount > 0 ? pendingSchedulesCount : ''} horarios configurados para esta campaña.
          <br />
          <br />
          {pendingOldHour && pendingNewHour && (
            <>
              Si cambia la hora programada principal de <strong>{pendingOldHour}</strong> a <strong>{pendingNewHour}</strong>, 
              todos los horarios subsecuentes existentes serán eliminados para evitar conflictos.
              <br />
              <br />
            </>
          )}
          ¿Desea continuar?
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (09/12/2025): Modal de confirmación para eliminar todos los horarios */}
      <ConfirmationModal
        title="Eliminar Todos los Horarios"
        open={confirmDeleteAllSchedulesModalOpen}
        onClose={() => {
          setConfirmDeleteAllSchedulesModalOpen(false);
        }}
        onConfirm={() => {
          if (formikSetFieldValueRef.current) {
            formikSetFieldValueRef.current('recurrenceHourlySchedules', []);
            toast.success("Todos los horarios fueron eliminados");
          }
          setConfirmDeleteAllSchedulesModalOpen(false);
        }}
        confirmText="Eliminar"
        cancelText="Cancelar"
      >
        <Box>
          ¿Eliminar todos los horarios configurados?
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (09/12/2025): Modal de confirmación para desactivar useHourlySchedule */}
      <ConfirmationModal
        title="⚠️ Desactivar Envío por Horas Múltiples"
        open={confirmDisableHourlyScheduleModalOpen}
        onClose={() => {
          setConfirmDisableHourlyScheduleModalOpen(false);
          setPendingSchedulesCount(0);
        }}
        onConfirm={() => {
          if (formikSetFieldValueRef.current) {
            formikSetFieldValueRef.current('useHourlySchedule', false);
            formikSetFieldValueRef.current('recurrenceHourlySchedules', []);
            toast.success("La opción 'Enviar por horas múltiples' fue desactivada y los horarios fueron eliminados");
            setPendingSchedulesCount(0);
          }
          setConfirmDisableHourlyScheduleModalOpen(false);
        }}
        confirmText="Continuar"
        cancelText="Cancelar"
      >
        <Box>
          Ya hay {pendingSchedulesCount > 0 ? pendingSchedulesCount : ''} horarios configurados para esta campaña.
          <br />
          <br />
          Si desactiva esta opción, todos los horarios subsecuentes existentes serán eliminados.
          <br />
          <br />
          ¿Desea continuar?
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (09/12/2025): Modal de Confirmación para cambio de Tipo de Recurrencia */}
      <ConfirmationModal
        title="⚠️ Cambio de Tipo de Recurrencia"
        open={confirmChangeRecurrenceTypeModalOpen}
        onClose={() => {
          setConfirmChangeRecurrenceTypeModalOpen(false);
          setPendingRecurrenceTypeChange(null);
          setPendingOldRecurrenceType(null);
          setPendingNewRecurrenceType(null);
          setPendingSchedulesCount(0);
        }}
        onConfirm={() => {
          if (formikSetFieldValueRef.current && pendingRecurrenceTypeChange !== null) {
            handleConfirmChangeRecurrenceType(formikSetFieldValueRef.current);
          }
        }}
        confirmText="Continuar"
        cancelText="Cancelar"
      >
        <Box>
          Ya hay {pendingSchedulesCount} horarios configurados (solo válidos para recurrencia diaria).
          <br /><br />
          Si cambia el tipo de recurrencia de <strong>"{pendingOldRecurrenceType}"</strong> a <strong>"{pendingNewRecurrenceType}"</strong>, 
          todos los horarios subsecuentes existentes serán eliminados y la opción "Enviar por horas múltiples" será desactivada automáticamente.
          <br /><br />
          ¿Desea continuar?
        </Box>
      </ConfirmationModal>

      {/* ✅ NUEVO (09/12/2025): Modal de Confirmación para deshabilitar Recurrencia */}
      <ConfirmationModal
        title="⚠️ Desactivar Recurrencia"
        open={confirmDisableRecurrenceModalOpen}
        onClose={() => {
          setConfirmDisableRecurrenceModalOpen(false);
          setPendingSchedulesCount(0);
        }}
        onConfirm={() => {
          if (formikSetFieldValueRef.current) {
            handleConfirmDisableRecurrence(formikSetFieldValueRef.current);
          }
        }}
        confirmText="Continuar"
        cancelText="Cancelar"
      >
        <Box>
          Ya hay {pendingSchedulesCount} horarios de envío configurados.
          <br /><br />
          Si desactiva la recurrencia, todos los horarios subsecuentes existentes serán eliminados junto con la configuración de recurrencia.
          <br /><br />
          ¿Desea continuar?
        </Box>
      </ConfirmationModal>

      {/* ✅ FASE 2: Modales de validación de fecha */}
      <Dialog
        open={datePastModalOpen}
        onClose={() => {
          setDatePastModalOpen(false);
          setPendingSetFieldValue(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Fecha pasada">📅</span> Fecha en el pasado
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>{datePastMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              setDatePastModalOpen(false);
              setPendingSetFieldValue(null);
            }} 
            color="default"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button 
            onClick={() => {
              // ✅ ACEPTAR: Actualizar fecha a hora actual + 2 minutos.
              // El backend recibe allowShortSchedule cuando este flujo confirma el envío cercano.
              const timezone = getCampaignTimezoneSync();
              const nowInCompanyTimezone = moment().tz(timezone);
              // Calcular hora actual + 2 minutos
              const newScheduledDate = nowInCompanyTimezone.add(2, 'minutes').format('YYYY-MM-DD HH:mm:ss');
              
              if (pendingSetFieldValue) {
                // Actualizar el campo en el formulario
                pendingSetFieldValue('scheduledDate', newScheduledDate);
              }
              
              // Si hay valores pendientes de guardado, actualizar scheduledDate y continuar
              if (pendingSaveValues && saveCampaignRef.current) {
                const updatedValues = { ...pendingSaveValues, scheduledDate: newScheduledDate };
                setPendingSaveValues(null);
                setDatePastModalOpen(false);
                setPendingSetFieldValue(null);
                // Continuar con el guardado (saltando validación de fecha pasada y tiempo corto)
                setTimeout(() => {
                  saveCampaignRef.current(updatedValues, true, true);
                }, 100);
              } else {
                setDatePastModalOpen(false);
                setPendingSetFieldValue(null);
                setPendingSaveValues(null);
              }
            }} 
            color="primary" 
            variant="contained"
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={shortTimeModalOpen}
        onClose={() => {
          setShortTimeModalOpen(false);
          setShortTimeMessage("");
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Tiempo corto">⏰</span> Tiempo de programación muy corto
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>{shortTimeMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              // ✅ CANCELAR: Cerrar modal sin hacer nada
              setShortTimeModalOpen(false);
              setShortTimeMessage("");
              setPendingScheduledAt(null);
            }} 
            color="default"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button 
            onClick={async () => {
              // ✅ ENTENDIDO: Aceptar la hora seleccionada y continuar
              const pendingSetFieldValueFn = pendingSetFieldValue;
              const scheduledDateValue = pendingScheduledAt;
              const pendingValues = pendingSaveValues;
              const saveFn = saveCampaignRef.current;
              
              // Cerrar modal
              setShortTimeModalOpen(false);
              setShortTimeMessage("");
              
              // Si viene desde onChange del campo, actualizar el campo
              if (pendingSetFieldValueFn && scheduledDateValue) {
                pendingSetFieldValueFn('scheduledDate', scheduledDateValue);
              }
              
              // Si viene desde processSave (botón AGREGAR), continuar con el guardado
              if (saveFn && pendingValues) {
                // Continuar con el guardado saltando la validación de tiempo corto
                setTimeout(() => {
                  saveFn(pendingValues, false, true); // shouldSkipShortTimeCheck = true
                }, 100);
              }
              
              // Limpiar valores pendientes
              setPendingScheduledAt(null);
            }} 
            color="primary" 
            variant="contained"
          >
            Entendido
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={formatInvalidModalOpen}
        onClose={() => setFormatInvalidModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Formato inválido">⚠️</span> Formato de archivo no permitido
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>{formatInvalidMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFormatInvalidModalOpen(false)} color="primary" variant="contained">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={sizeExceededModalOpen}
        onClose={() => setSizeExceededModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <span role="img" aria-label="Tamaño excedido">⚠️</span> Tamaño de archivo excedido
        </DialogTitle>
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>
            El archivo seleccionado excede el tamaño máximo permitido. Por favor, seleccione un archivo más pequeño.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSizeExceededModalOpen(false)} color="primary" variant="contained">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default GroupCampaignModal;
